export const countries = {
  AF: 'Afghanistan',
  AX: 'Åland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brasil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos  Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, The Democratic Republic Of The',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Côte D'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GW: 'Guinea-Bissau',
  GN: 'Guinea',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard & McDonald Islands',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea, Democratic People's Republic Of",
  KR: 'Korea, Republic of',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macau',
  MK: 'Macedonia, the Former Yugoslav Republic Of',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States Of',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NG: 'Nigeria',
  NE: 'Niger',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russia',
  RW: 'Rwanda',
  SH: 'Saint Helena, Ascension and Tristan Da Cunha',
  KN: 'Saint Kitts And Nevis',
  LC: 'Saint Lucia',
  VC: 'Saint Vincent And The Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  GS: 'S.Georgia & S.Sandwich Islands',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  BL: 'St. Barthélemy',
  SX: 'St. Maarten',
  MF: 'St. Martin',
  PM: 'St. Pierre & Miquelon',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard & Jan Mayen Islands',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syria',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'East Timor',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks & Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  UM: 'United States Minor Outlying Islands',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VA: 'Vatican City',
  VE: 'Venezuela',
  VN: 'Viet Nam',
  VG: 'Virgin Islands',
  VI: 'Virgin Islands',
  WF: 'Wallis & Futuna Islands',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}

export const countriesStates = {
  AF: {
    BAL: 'Balkh',
    BAM: 'Bāmyān',
    BDG: 'Bādghīs',
    BDS: 'Badakhshān',
    BGL: 'Baghlān',
    DAY: 'Dāykundī',
    FRA: 'Farāh',
    FYB: 'Fāryāb',
    GHA: 'Ghaznī',
    GHO: 'Ghōr',
    HEL: 'Helmand',
    HER: 'Herāt',
    JOW: 'Jowzjān',
    KAB: 'Kābul',
    KAN: 'Kandahār',
    KAP: 'Kāpīsā',
    KDZ: 'Kunduz',
    KHO: 'Khōst',
    KNR: 'Kunar',
    LAG: 'Laghmān',
    LOG: 'Lōgar',
    NAN: 'Nangarhār',
    NIM: 'Nīmrōz',
    NUR: 'Nūristān',
    PAN: 'Panjshayr',
    PAR: 'Parwān',
    PIA: 'Paktiyā',
    PKA: 'Paktīkā',
    SAM: 'Samangān',
    SAR: 'Sar-e Pul',
    TAK: 'Takhār',
    URU: 'Uruzgān',
    WAR: 'Wardak',
    ZAB: 'Zābul',
  },
  AX: {
    AX: 'Åland Islands',
  },
  AL: {
    '10': 'Shkodër',
    '11': 'Tiranë',
    '12': 'Vlorë',
    '01': 'Berat',
    '02': 'Durrës',
    '03': 'Elbasan',
    '04': 'Fier',
    '05': 'Gjirokastër',
    '06': 'Korçë',
    '07': 'Kukës',
    '08': 'Lezhë',
    '09': 'Dibër',
    BR: 'Berat',
    BU: 'Bulqizë',
    DI: 'Dibër',
    DL: 'Delvinë',
    DR: 'Durrës',
    DV: 'Devoll',
    EL: 'Elbasan',
    ER: 'Kolonjë',
    FR: 'Fier',
    GJ: 'Gjirokastër',
    GR: 'Gramsh',
    HA: 'Has',
    KA: 'Kavajë',
    KB: 'Kurbin',
    KC: 'Kuçovë',
    KO: 'Korçë',
    KR: 'Krujë',
    KU: 'Kukës',
    LB: 'Librazhd',
    LE: 'Lezhë',
    LU: 'Lushnjë',
    MK: 'Mallakastër',
    MM: 'Malësi e Madhe',
    MR: 'Mirditë',
    MT: 'Mat',
    PG: 'Pogradec',
    PQ: 'Peqin',
    PR: 'Përmet',
    PU: 'Pukë',
    SH: 'Shkodër',
    SK: 'Skrapar',
    SR: 'Sarandë',
    TE: 'Tepelenë',
    TP: 'Tropojë',
    TR: 'Tiranë',
    VL: 'Vlorë',
  },
  DZ: {
    '10': 'Bouira',
    '11': 'Tamanrasset',
    '12': 'Tébessa',
    '13': 'Tlemcen',
    '14': 'Tiaret',
    '15': 'Tizi Ouzou',
    '16': 'Alger',
    '17': 'Djelfa',
    '18': 'Jijel',
    '19': 'Sétif',
    '20': 'Saïda',
    '21': 'Skikda',
    '22': 'Sidi Bel Abbès',
    '23': 'Annaba',
    '24': 'Guelma',
    '25': 'Constantine',
    '26': 'Médéa',
    '27': 'Mostaganem',
    '28': 'Msila',
    '29': 'Mascara',
    '30': 'Ouargla',
    '31': 'Oran',
    '32': 'El Bayadh',
    '33': 'Illizi',
    '34': 'Bordj Bou Arréridj',
    '35': 'Boumerdès',
    '36': 'El Tarf',
    '37': 'Tindouf',
    '38': 'Tissemsilt',
    '39': 'El Oued',
    '40': 'Khenchela',
    '41': 'Souk Ahras',
    '42': 'Tipaza',
    '43': 'Mila',
    '44': 'Aïn Defla',
    '45': 'Naama',
    '46': 'Aïn Témouchent',
    '47': 'Ghardaïa',
    '48': 'Relizane',
    '01': 'Adrar',
    '02': 'Chlef',
    '03': 'Laghouat',
    '04': 'Oum el Bouaghi',
    '05': 'Batna',
    '06': 'Béjaïa',
    '07': 'Biskra',
    '08': 'Béchar',
    '09': 'Blida',
  },
  AS: {
    AS: 'American Samoa',
  },
  AD: {
    '02': 'Canillo',
    '03': 'Encamp',
    '04': 'La Massana',
    '05': 'Ordino',
    '06': 'Sant Julià de Lòria',
    '07': 'Andorra la Vella',
    '08': 'Escaldes-Engordany',
  },
  AO: {
    BGO: 'Bengo',
    BGU: 'Benguela',
    BIE: 'Bié',
    CAB: 'Cabinda',
    CCU: 'Kuando Kubango',
    CNN: 'Cunene',
    CNO: 'Kwanza Norte',
    CUS: 'Kwanza Sul',
    HUA: 'Huambo',
    HUI: 'Huíla',
    LNO: 'Lunda Norte',
    LSU: 'Lunda Sul',
    LUA: 'Luanda',
    MAL: 'Malange',
    MOX: 'Moxico',
    NAM: 'Namibe',
    UIG: 'Uíge',
    ZAI: 'Zaire',
  },
  AI: {
    AI: 'Anguilla',
  },
  AQ: {
    AQ: 'Antarctica',
  },
  AG: {
    '10': 'Barbuda',
    '11': 'Redonda',
    '03': 'Saint George',
    '04': 'Saint John',
    '05': 'Saint Mary',
    '06': 'Saint Paul',
    '07': 'Saint Peter',
    '08': 'Saint Philip',
  },
  AR: {
    A: 'Salta',
    B: 'Buenos Aires',
    C: 'Ciudad Autónoma de Buenos Aires',
    D: 'San Luis',
    E: 'Entre Ríos',
    F: 'La Rioja',
    G: 'Santiago del Estero',
    H: 'Chaco',
    J: 'San Juan',
    K: 'Catamarca',
    L: 'La Pampa',
    M: 'Mendoza',
    N: 'Misiones',
    P: 'Formosa',
    Q: 'Neuquén',
    R: 'Río Negro',
    S: 'Santa Fe',
    T: 'Tucumán',
    U: 'Chubut',
    V: 'Tierra del Fuego',
    W: 'Corrientes',
    X: 'Córdoba',
    Y: 'Jujuy',
    Z: 'Santa Cruz',
  },
  AM: {
    AG: 'Aragac̣otn',
    AR: 'Ararat',
    AV: 'Armavir',
    ER: 'Erevan',
    GR: "Geġark'unik'",
    KT: "Kotayk'",
    LO: 'Loṙi',
    SH: 'Širak',
    SU: "Syunik'",
    TV: 'Tavuš',
    VD: 'Vayoć Jor',
  },
  AW: {
    AW: 'Aruba',
  },
  AU: {
    ACT: 'Australian Capital Territory',
    NSW: 'New South Wales',
    NT: 'Northern Territory',
    QLD: 'Queensland',
    SA: 'South Australia',
    TAS: 'Tasmania',
    VIC: 'Victoria',
    WA: 'Western Australia',
  },
  AT: {
    '1': 'Burgenland',
    '2': 'Kärnten',
    '3': 'Niederösterreich',
    '4': 'Oberösterreich',
    '5': 'Salzburg',
    '6': 'Steiermark',
    '7': 'Tirol',
    '8': 'Vorarlberg',
    '9': 'Wien',
  },
  AZ: {
    ABS: 'Abşeron',
    AGA: 'Ağstafa',
    AGC: 'Ağcabәdi',
    AGM: 'Ağdam',
    AGS: 'Ağdaş',
    AGU: 'Ağsu',
    AST: 'Astara',
    BA: 'Bakı',
    BAB: 'Babək',
    BAL: 'Balakən',
    BAR: 'Bərdə',
    BEY: 'Beyləqan',
    BIL: 'Biləsuvar',
    CAB: 'Cəbrayıl',
    CAL: 'Cəlilabad',
    CUL: 'Culfa',
    DAS: 'Daşkəsən',
    FUZ: 'Füzuli',
    GAD: 'Gədəbəy',
    GA: 'Gәncә',
    GOR: 'Goranboy',
    GOY: 'Göyçay',
    GYG: 'Göygöl',
    HAC: 'Hacıqabul',
    IMI: 'İmişli',
    ISM: 'İsmayıllı',
    KAL: 'Kəlbəcər',
    KAN: 'Kǝngǝrli',
    KUR: 'Kürdəmir',
    LAC: 'Laçın',
    LA: 'Lәnkәran',
    LAN: 'Lənkəran',
    LER: 'Lerik',
    MAS: 'Masallı',
    MI: 'Mingәçevir',
    NA: 'Naftalan',
    NEF: 'Neftçala',
    NV: 'Naxçıvan',
    NX: 'Naxçıvan',
    OGU: 'Oğuz',
    ORD: 'Ordubad',
    QAB: 'Qәbәlә',
    QAX: 'Qax',
    QAZ: 'Qazax',
    QBA: 'Quba',
    QBI: 'Qubadlı',
    QOB: 'Qobustan',
    QUS: 'Qusar',
    SAB: 'Sabirabad',
    SAD: 'Sәdәrәk',
    SAH: 'Şahbuz',
    SAK: 'Şәki',
    SAL: 'Salyan',
    SAR: 'Şәrur',
    SA: 'Şәki',
    SAT: 'Saatlı',
    SBN: 'Şabran',
    SIY: 'Siyәzәn',
    SKR: 'Şәmkir',
    SMI: 'Şamaxı',
    SM: 'Sumqayıt',
    SMX: 'Samux',
    SR: 'Şirvan',
    SUS: 'Şuşa',
    TAR: 'Tәrtәr',
    TOV: 'Tovuz',
    UCA: 'Ucar',
    XAC: 'Xaçmaz',
    XA: 'Xankәndi',
    XCI: 'Xocalı',
    XIZ: 'Xızı',
    XVD: 'Xocavәnd',
    YAR: 'Yardımlı',
    YEV: 'Yevlax',
    YE: 'Yevlax',
    ZAN: 'Zәngilan',
    ZAQ: 'Zaqatala',
    ZAR: 'Zәrdab',
  },
  BS: {
    AK: 'Acklins',
    BI: 'Bimini',
    BP: 'Black Point',
    BY: 'Berry Islands',
    CE: 'Central Eleuthera',
    CI: 'Cat Island',
    CK: 'Crooked Island and Long Cay',
    CO: 'Central Abaco',
    CS: 'Central Andros',
    EG: 'East Grand Bahama',
    EX: 'Exuma',
    FP: 'City of Freeport',
    GC: 'Grand Cay',
    HI: 'Harbour Island',
    HT: 'Hope Town',
    IN: 'Inagua',
    LI: 'Long Island',
    MC: 'Mangrove Cay',
    MG: 'Mayaguana',
    MI: "Moore's Island",
    NE: 'North Eleuthera',
    NO: 'North Abaco',
    NS: 'North Andros',
    RC: 'Rum Cay',
    RI: 'Ragged Island',
    SA: 'South Andros',
    SE: 'South Eleuthera',
    SO: 'South Abaco',
    SS: 'San Salvador',
    SW: 'Spanish Wells',
    WG: 'West Grand Bahama',
  },
  BH: {
    '13': 'Al Manāmah',
    '14': 'Al Janūbīyah',
    '15': 'Al Muḩarraq',
    '16': 'Al Wusţá',
    '17': 'Ash Shamālīyah',
  },
  BD: {
    '10': 'Chittagong',
    '11': "Cox's Bazar",
    '12': 'Chuadanga',
    '13': 'Dhaka',
    '14': 'Dinajpur',
    '15': 'Faridpur',
    '16': 'Feni',
    '17': 'Gopalganj',
    '18': 'Gazipur',
    '19': 'Gaibandha',
    '20': 'Habiganj',
    '21': 'Jamalpur',
    '22': 'Jessore',
    '23': 'Jhenaidah',
    '24': 'Jaipurhat',
    '25': 'Jhalakati',
    '26': 'Kishoreganj',
    '27': 'Khulna',
    '28': 'Kurigram',
    '29': 'Khagrachari',
    '30': 'Kushtia',
    '31': 'Lakshmipur',
    '32': 'Lalmonirhat',
    '33': 'Manikganj',
    '34': 'Mymensingh',
    '35': 'Munshiganj',
    '36': 'Madaripur',
    '37': 'Magura',
    '38': 'Moulvibazar',
    '39': 'Meherpur',
    '40': 'Narayanganj',
    '41': 'Netrakona',
    '42': 'Narsingdi',
    '43': 'Narail',
    '44': 'Natore',
    '45': 'Nawabganj',
    '46': 'Nilphamari',
    '47': 'Noakhali',
    '48': 'Naogaon',
    '49': 'Pabna',
    '50': 'Pirojpur',
    '51': 'Patuakhali',
    '52': 'Panchagarh',
    '53': 'Rajbari',
    '54': 'Rajshahi',
    '55': 'Rangpur',
    '56': 'Rangamati',
    '57': 'Sherpur',
    '58': 'Satkhira',
    '59': 'Sirajganj',
    '60': 'Sylhet',
    '61': 'Sunamganj',
    '62': 'Shariatpur',
    '63': 'Tangail',
    '64': 'Thakurgaon',
    '01': 'Bandarban',
    '02': 'Barguna',
    '03': 'Bogra',
    '04': 'Brahmanbaria',
    '05': 'Bagerhat',
    '06': 'Barisal',
    '07': 'Bhola',
    '08': 'Comilla',
    '09': 'Chandpur',
    A: 'Barisal',
    B: 'Chittagong',
    C: 'Dhaka',
    D: 'Khulna',
    E: 'Rajshahi',
    F: 'Rangpur',
    G: 'Sylhet',
  },
  BB: {
    '10': 'Saint Philip',
    '11': 'Saint Thomas',
    '01': 'Christ Church',
    '02': 'Saint Andrew',
    '03': 'Saint George',
    '04': 'Saint James',
    '05': 'Saint John',
    '06': 'Saint Joseph',
    '07': 'Saint Lucy',
    '08': 'Saint Michael',
    '09': 'Saint Peter',
  },
  BY: {
    BR: 'Bresckaja voblasć',
    HM: 'Gorod Minsk',
    HO: "Gomel'skaja oblast'",
    HR: "Grodnenskaja oblast'",
    MA: 'Mahilioŭskaja voblasć',
    MI: "Minskaja oblast'",
    VI: 'Viciebskaja voblasć',
  },
  BE: {
    BRU: 'Brussels Hoofdstedelijk Gewest',
    VAN: 'Antwerpen',
    VBR: 'Vlaams-Brabant',
    VLG: 'Vlaams Gewest',
    VLI: 'Limburg',
    VOV: 'Oost-Vlaanderen',
    VWV: 'West-Vlaanderen',
    WAL: 'wallonne, Région',
    WBR: 'Brabant wallon',
    WHT: 'Hainaut',
    WLG: 'Liège',
    WLX: 'Luxembourg',
    WNA: 'Namur',
  },
  BZ: {
    BZ: 'Belize',
    CY: 'Cayo',
    CZL: 'Corozal',
    OW: 'Orange Walk',
    SC: 'Stann Creek',
    TOL: 'Toledo',
  },
  BJ: {
    AK: 'Atakora',
    AL: 'Alibori',
    AQ: 'Atlantique',
    BO: 'Borgou',
    CO: 'Collines',
    DO: 'Donga',
    KO: 'Kouffo',
    LI: 'Littoral',
    MO: 'Mono',
    OU: 'Ouémé',
    PL: 'Plateau',
    ZO: 'Zou',
  },
  BM: {
    BM: 'Bermuda',
  },
  BT: {
    '11': 'Paro',
    '12': 'Chhukha',
    '13': 'Ha',
    '14': 'Samtse',
    '15': 'Thimphu',
    '21': 'Tsirang',
    '22': 'Dagana',
    '23': 'Punakha',
    '24': 'Wangdue Phodrang',
    '31': 'Sarpang',
    '32': 'Trongsa',
    '33': 'Bumthang',
    '34': 'Zhemgang',
    '41': 'Trashigang',
    '42': 'Monggar',
    '43': 'Pemagatshel',
    '44': 'Lhuentse',
    '45': 'Samdrup Jongkha',
    GA: 'Gasa',
    TY: 'Trashi Yangtse',
  },
  BO: {
    B: 'El Beni',
    C: 'Cochabamba',
    H: 'Chuquisaca',
    L: 'La Paz',
    N: 'Pando',
    O: 'Oruro',
    P: 'Potosí',
    S: 'Santa Cruz',
    T: 'Tarija',
  },
  BQ: {
    BO: 'Bonaire',
    SA: 'Saba',
    SE: 'Sint Eustatius',
  },
  BA: {
    '10': 'Kanton br. 10',
    '01': 'Unsko-sanska županija',
    '02': 'Posavska županija',
    '03': 'Tuzlanska županija',
    '04': 'Zeničko-dobojska županija',
    '05': 'Bosansko-podrinjska županija',
    '06': 'Srednjobosanska županija',
    '07': 'Hercegovačko-neretvanska županija',
    '08': 'Zapadnohercegovačka županija',
    '09': 'Kanton Sarajevo',
    BIH: 'Federacija Bosne i Hercegovine',
    BRC: 'Brčko distrikt',
    SRP: 'Republika Srpska',
  },
  BW: {
    CE: 'Central',
    CH: 'Chobe',
    FR: 'Francistown',
    GA: 'Gaborone',
    GH: 'Ghanzi',
    JW: 'Jwaneng',
    KG: 'Kgalagadi',
    KL: 'Kgatleng',
    KW: 'Kweneng',
    LO: 'Lobatse',
    NE: 'North East',
    NW: 'North West',
    SE: 'South East',
    SO: 'Southern',
    SP: 'Selibe Phikwe',
    ST: 'Sowa Town',
  },
  BV: {
    BV: 'Bouvet Island',
  },
  BR: {
    AC: 'Acre',
    AL: 'Alagoas',
    AM: 'Amazonas',
    AP: 'Amapá',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MG: 'Minas Gerais',
    MS: 'Mato Grosso do Sul',
    MT: 'Mato Grosso',
    PA: 'Pará',
    PB: 'Paraíba',
    PE: 'Pernambuco',
    PI: 'Piauí',
    PR: 'Paraná',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RO: 'Rondônia',
    RR: 'Roraima',
    RS: 'Rio Grande do Sul',
    SC: 'Santa Catarina',
    SE: 'Sergipe',
    SP: 'São Paulo',
    TO: 'Tocantins',
  },
  IO: {
    IO: 'British Indian Ocean Territory',
  },
  BN: {
    BE: 'Belait',
    BM: 'Brunei-Muara',
    TE: 'Temburong',
    TU: 'Tutong',
  },
  BG: {
    '10': 'Kyustendil',
    '11': 'Lovech',
    '12': 'Montana',
    '13': 'Pazardzhik',
    '14': 'Pernik',
    '15': 'Pleven',
    '16': 'Plovdiv',
    '17': 'Razgrad',
    '18': 'Ruse',
    '19': 'Silistra',
    '20': 'Sliven',
    '21': 'Smolyan',
    '22': 'Sofia',
    '23': 'Sofia',
    '24': 'Stara Zagora',
    '25': 'Targovishte',
    '26': 'Haskovo',
    '27': 'Shumen',
    '28': 'Yambol',
    '01': 'Blagoevgrad',
    '02': 'Burgas',
    '03': 'Varna',
    '04': 'Veliko Tarnovo',
    '05': 'Vidin',
    '06': 'Vratsa',
    '07': 'Gabrovo',
    '08': 'Dobrich',
    '09': 'Kardzhali',
  },
  BF: {
    '10': 'Nord',
    '11': 'Plateau-Central',
    '12': 'Sahel',
    '13': 'Sud-Ouest',
    '01': 'Boucle du Mouhoun',
    '02': 'Cascades',
    '03': 'Centre',
    '04': 'Centre-Est',
    '05': 'Centre-Nord',
    '06': 'Centre-Ouest',
    '07': 'Centre-Sud',
    '08': 'Est',
    '09': 'Hauts-Bassins',
    BAL: 'Balé',
    BAM: 'Bam',
    BAN: 'Banwa',
    BAZ: 'Bazèga',
    BGR: 'Bougouriba',
    BLG: 'Boulgou',
    BLK: 'Boulkiemdé',
    COM: 'Comoé',
    GAN: 'Ganzourgou',
    GNA: 'Gnagna',
    GOU: 'Gourma',
    HOU: 'Houet',
    IOB: 'Ioba',
    KAD: 'Kadiogo',
    KEN: 'Kénédougou',
    KMD: 'Komondjari',
    KMP: 'Kompienga',
    KOP: 'Koulpélogo',
    KOS: 'Kossi',
    KOT: 'Kouritenga',
    KOW: 'Kourwéogo',
    LER: 'Léraba',
    LOR: 'Loroum',
    MOU: 'Mouhoun',
    NAM: 'Namentenga',
    NAO: 'Nahouri',
    NAY: 'Nayala',
    NOU: 'Noumbiel',
    OUB: 'Oubritenga',
    OUD: 'Oudalan',
    PAS: 'Passoré',
    PON: 'Poni',
    SEN: 'Séno',
    SIS: 'Sissili',
    SMT: 'Sanmatenga',
    SNG: 'Sanguié',
    SOM: 'Soum',
    SOR: 'Sourou',
    TAP: 'Tapoa',
    TUI: 'Tui',
    YAG: 'Yagha',
    YAT: 'Yatenga',
    ZIR: 'Ziro',
    ZON: 'Zondoma',
    ZOU: 'Zoundwéogo',
  },
  BI: {
    BB: 'Bubanza',
    BL: 'Bujumbura Rural',
    BM: 'Bujumbura Mairie',
    BR: 'Bururi',
    CA: 'Cankuzo',
    CI: 'Cibitoke',
    GI: 'Gitega',
    KI: 'Kirundo',
    KR: 'Karuzi',
    KY: 'Kayanza',
    MA: 'Makamba',
    MU: 'Muramvya',
    MW: 'Mwaro',
    MY: 'Muyinga',
    NG: 'Ngozi',
    RT: 'Rutana',
    RY: 'Ruyigi',
  },
  KH: {
    '1': 'Bântéay Méanchey',
    '2': 'Baat Dambang',
    '3': 'Kampong Chaam',
    '4': 'Kampong Chhnang',
    '5': 'Kâmpóng Spœ',
    '6': 'Kâmpóng Thum',
    '7': 'Kampot',
    '8': 'Kandaal',
    '9': 'Kaoh Kong',
    '10': 'Krâchéh',
    '11': 'Môndól Kiri',
    '12': 'Phnom Penh',
    '13': 'Preăh Vihéar',
    '14': 'Prey Veaeng',
    '15': 'Pousaat',
    '16': 'Rotanak Kiri',
    '17': 'Siem Reab',
    '18': 'Krŏng Preăh Sihanouk',
    '19': 'Stoĕng Trêng',
    '20': 'Svaay Rieng',
    '21': 'Taakaev',
    '22': 'Ŏtdâr Méanchey',
    '23': 'Krong Kaeb',
    '24': 'Krŏng Pailĭn',
  },
  CM: {
    AD: 'Adamaoua',
    CE: 'Centre',
    EN: 'Extrême-Nord',
    ES: 'East',
    LT: 'Littoral',
    NO: 'Nord',
    NW: 'Nord-Ouest',
    OU: 'Ouest',
    SU: 'South',
    SW: 'South-West',
  },
  CA: {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
  },
  CV: {
    B: 'Ilhas de Barlavento',
    BR: 'Brava',
    BV: 'Boa Vista',
    CA: 'Santa Catarina',
    CF: 'Santa Catarina do Fogo',
    CR: 'Santa Cruz',
    MA: 'Maio',
    MO: 'Mosteiros',
    PA: 'Paul',
    PN: 'Porto Novo',
    PR: 'Praia',
    RB: 'Ribeira Brava',
    RG: 'Ribeira Grande',
    RS: 'Ribeira Grande de Santiago',
    SD: 'São Domingos',
    SF: 'São Filipe',
    S: 'Ilhas de Sotavento',
    SL: 'Sal',
    SM: 'São Miguel',
    SO: 'São Lourenço dos Órgãos',
    SS: 'São Salvador do Mundo',
    SV: 'São Vicente',
    TA: 'Tarrafal',
    TS: 'Tarrafal de São Nicolau',
  },
  KY: {
    KY: 'Cayman Islands',
  },
  CF: {
    AC: 'Ouham',
    BB: 'Bamïngï-Bangoran',
    BGF: 'Bangî',
    BK: 'Basse-Kotto',
    HK: 'Haute-Kotto',
    HM: 'Haut-Mbomou',
    HS: 'Haute-Sangha / Mambéré-Kadéï',
    KB: 'Gïrïbïngï',
    KG: 'Kemö-Gïrïbïngï',
    LB: 'Lobaye',
    MB: 'Mbomou',
    MP: 'Ömbëlä-Pökö',
    NM: 'Nana-Mambéré',
    OP: 'Ouham-Pendé',
    SE: 'Sangä',
    UK: 'Ouaka',
    VK: 'Vakaga',
  },
  TD: {
    BA: 'Al Baţḩah',
    BG: 'Baḩr al Ghazāl',
    BO: 'Borkou',
    CB: 'Chari-Baguirmi',
    EE: 'Ennedi-Est',
    EO: 'Ennedi-Ouest',
    GR: 'Guéra',
    HL: 'Hadjer Lamis',
    KA: 'Kanem',
    LC: 'Al Buḩayrah',
    LO: 'Logone-Occidental',
    LR: 'Logone-Oriental',
    MA: 'Mandoul',
    MC: 'Moyen-Chari',
    ME: 'Mayo-Kebbi-Est',
    MO: 'Mayo-Kebbi-Ouest',
    ND: 'Madīnat Injamīnā',
    OD: 'Ouaddaï',
    SA: 'Salamat',
    SI: 'Sila',
    TA: 'Tandjilé',
    TI: 'Tibastī',
    WF: 'Wadi Fira',
  },
  CL: {
    AI: 'Aysén',
    AN: 'Antofagasta',
    AP: 'Arica y Parinacota',
    AR: 'Araucanía',
    AT: 'Atacama',
    BI: 'Biobío',
    CO: 'Coquimbo',
    LI: "Libertador General Bernardo O'Higgins",
    LL: 'Los Lagos',
    LR: 'Los Ríos',
    MA: 'Magallanes',
    ML: 'Maule',
    RM: 'Región Metropolitana de Santiago',
    TA: 'Tarapacá',
    VS: 'Valparaíso',
  },
  CN: {
    '11': 'Beijing',
    '12': 'Tianjin',
    '13': 'Hebei',
    '14': 'Shanxi',
    '15': 'Nei Mongol',
    '21': 'Liaoning',
    '22': 'Jilin',
    '23': 'Heilongjiang',
    '31': 'Shanghai',
    '32': 'Jiangsu',
    '33': 'Zhejiang',
    '34': 'Anhui',
    '35': 'Fujian',
    '36': 'Jiangxi',
    '37': 'Shandong',
    '41': 'Henan',
    '42': 'Hubei',
    '43': 'Hunan',
    '44': 'Guangdong',
    '45': 'Guangxi',
    '46': 'Hainan',
    '50': 'Chongqing',
    '51': 'Sichuan',
    '52': 'Guizhou',
    '53': 'Yunnan',
    '54': 'Xizang',
    '61': 'Shaanxi',
    '62': 'Gansu',
    '63': 'Qinghai',
    '64': 'Ningxia',
    '65': 'Xinjiang',
    '71': 'Taiwan',
    '91': 'Hong Kong',
    '92': 'Aomen',
  },
  CX: {
    CX: 'Christmas Island',
  },
  CC: {
    CC: 'Cocos  Islands',
  },
  CO: {
    AMA: 'Amazonas',
    ANT: 'Antioquia',
    ARA: 'Arauca',
    ATL: 'Atlántico',
    BOL: 'Bolívar',
    BOY: 'Boyacá',
    CAL: 'Caldas',
    CAQ: 'Caquetá',
    CAS: 'Casanare',
    CAU: 'Cauca',
    CES: 'Cesar',
    CHO: 'Chocó',
    COR: 'Córdoba',
    CUN: 'Cundinamarca',
    DC: 'Distrito Capital de Bogotá',
    GUA: 'Guainía',
    GUV: 'Guaviare',
    HUI: 'Huila',
    LAG: 'La Guajira',
    MAG: 'Magdalena',
    MET: 'Meta',
    NAR: 'Nariño',
    NSA: 'Norte de Santander',
    PUT: 'Putumayo',
    QUI: 'Quindío',
    RIS: 'Risaralda',
    SAN: 'Santander',
    SAP: 'San Andrés, Providencia y Santa Catalina',
    SUC: 'Sucre',
    TOL: 'Tolima',
    VAC: 'Valle del Cauca',
    VAU: 'Vaupés',
    VID: 'Vichada',
  },
  KM: {
    A: 'Andjouân',
    G: 'Andjazîdja',
    M: 'Mohéli',
  },
  CG: {
    '2': 'Lékoumou',
    '5': 'Kouilou',
    '7': 'Likouala',
    '8': 'Cuvette',
    '9': 'Niari',
    '11': 'Bouenza',
    '12': 'Pool',
    '13': 'Sangha',
    '14': 'Plateaux',
    '15': 'Cuvette-Ouest',
    '16': 'Pointe-Noire',
    BZV: 'Brazzaville',
  },
  CD: {
    BC: 'Bas-Congo',
    BN: 'Bandundu',
    EQ: 'Équateur',
    KA: 'Katanga',
    KE: 'Kasai-Oriental',
    KN: 'Kinshasa',
    KW: 'Kasai-Occidental',
    MA: 'Maniema',
    NK: 'Nord-Kivu',
    OR: 'Orientale',
    SK: 'Sud-Kivu',
  },
  CK: {
    CK: 'Cook Islands',
  },
  CR: {
    A: 'Alajuela',
    C: 'Cartago',
    G: 'Guanacaste',
    H: 'Heredia',
    L: 'Limón',
    P: 'Puntarenas',
    SJ: 'San José',
  },
  CI: {
    '10': 'Denguélé',
    '11': 'Nzi-Comoé',
    '12': 'Marahoué',
    '13': 'Sud-Comoé',
    '14': 'Worodougou',
    '15': 'Sud-Bandama',
    '16': 'Agnébi',
    '17': 'Bafing',
    '18': 'Fromager',
    '19': 'Moyen-Cavally',
    '01': 'Lagunes',
    '02': 'Haut-Sassandra',
    '03': 'Savanes',
    '04': 'Vallée du Bandama',
    '05': 'Moyen-Comoé',
    '06': '18 Montagnes',
    '07': 'Lacs',
    '08': 'Zanzan',
    '09': 'Bas-Sassandra',
  },
  HR: {
    '10': 'Virovitičko-podravska županija',
    '11': 'Požeško-slavonska županija',
    '12': 'Brodsko-posavska županija',
    '13': 'Zadarska županija',
    '14': 'Osječko-baranjska županija',
    '15': 'Šibensko-kninska županija',
    '16': 'Vukovarsko-srijemska županija',
    '17': 'Splitsko-dalmatinska županija',
    '18': 'Istarska županija',
    '19': 'Dubrovačko-neretvanska županija',
    '20': 'Međimurska županija',
    '21': 'Grad Zagreb',
    '01': 'Zagrebačka županija',
    '02': 'Krapinsko-zagorska županija',
    '03': 'Sisačko-moslavačka županija',
    '04': 'Karlovačka županija',
    '05': 'Varaždinska županija',
    '06': 'Koprivničko-križevačka županija',
    '07': 'Bjelovarsko-bilogorska županija',
    '08': 'Primorsko-goranska županija',
    '09': 'Ličko-senjska županija',
  },
  CU: {
    '10': 'Las Tunas',
    '11': 'Holguín',
    '12': 'Granma',
    '13': 'Santiago de Cuba',
    '14': 'Guantánamo',
    '15': 'Artemisa',
    '16': 'Mayabeque',
    '99': 'Isla de la Juventud',
    '01': 'Pinar del Río',
    '03': 'La Habana',
    '04': 'Matanzas',
    '05': 'Villa Clara',
    '06': 'Cienfuegos',
    '07': 'Sancti Spíritus',
    '08': 'Ciego de Ávila',
    '09': 'Camagüey',
  },
  CW: {
    CW: 'Curaçao',
  },
  CY: {
    '01': 'Lefkoşa',
    '02': 'Lemesos',
    '03': 'Larnaka',
    '04': 'Ammochostos',
    '05': 'Baf',
    '06': 'Girne',
  },
  CZ: {
    '101': 'Praha 1',
    '102': 'Praha 2',
    '103': 'Praha 3',
    '104': 'Praha 4',
    '105': 'Praha 5',
    '106': 'Praha 6',
    '107': 'Praha 7',
    '108': 'Praha 8',
    '109': 'Praha 9',
    '201': 'Benešov',
    '202': 'Beroun',
    '203': 'Kladno',
    '204': 'Kolín',
    '205': 'Kutná Hora',
    '206': 'Mělník',
    '207': 'Mladá Boleslav',
    '208': 'Nymburk',
    '209': 'Praha-východ',
    '311': 'České Budějovice',
    '312': 'Český Krumlov',
    '313': 'Jindřichův Hradec',
    '314': 'Písek',
    '315': 'Prachatice',
    '316': 'Strakonice',
    '317': 'Tábor',
    '321': 'Domažlice',
    '322': 'Klatovy',
    '323': 'Plzeň-město',
    '324': 'Plzeň-jih',
    '325': 'Plzeň-sever',
    '326': 'Rokycany',
    '327': 'Tachov',
    '411': 'Cheb',
    '412': 'Karlovy Vary',
    '413': 'Sokolov',
    '421': 'Děčín',
    '422': 'Chomutov',
    '423': 'Litoměřice',
    '424': 'Louny',
    '425': 'Most',
    '426': 'Teplice',
    '427': 'Ústí nad Labem',
    '511': 'Česká Lípa',
    '512': 'Jablonec nad Nisou',
    '513': 'Liberec',
    '514': 'Semily',
    '521': 'Hradec Králové',
    '522': 'Jičín',
    '523': 'Náchod',
    '524': 'Rychnov nad Kněžnou',
    '525': 'Trutnov',
    '531': 'Chrudim',
    '532': 'Pardubice',
    '533': 'Svitavy',
    '534': 'Ústí nad Orlicí',
    '611': 'Havlíčkův Brod',
    '612': 'Jihlava',
    '613': 'Pelhřimov',
    '614': 'Třebíč',
    '615': "Žd'ár nad Sázavou",
    '621': 'Blansko',
    '622': 'Brno-město',
    '623': 'Brno-venkov',
    '624': 'Břeclav',
    '625': 'Hodonín',
    '626': 'Vyškov',
    '627': 'Znojmo',
    '711': 'Jeseník',
    '712': 'Olomouc',
    '713': 'Prostĕjov',
    '714': 'Přerov',
    '715': 'Šumperk',
    '721': 'Kromĕříž',
    '722': 'Uherské Hradištĕ',
    '723': 'Vsetín',
    '724': 'Zlín',
    '801': 'Bruntál',
    '802': 'Frýdek Místek',
    '803': 'Karviná',
    '804': 'Nový Jičín',
    '805': 'Opava',
    '806': 'Ostrava město',
    '10A': 'Praha 10',
    '10B': 'Praha 11',
    '10C': 'Praha 12',
    '10D': 'Praha 13',
    '10E': 'Praha 14',
    '10F': 'Praha 15',
    '20A': 'Praha-západ',
    '20B': 'Příbram',
    '20C': 'Rakovník',
    JC: 'Jihočeský kraj',
    JM: 'Jihomoravský kraj',
    KA: 'Karlovarský kraj',
    KR: 'Královéhradecký kraj',
    LI: 'Liberecký kraj',
    MO: 'Moravskoslezský kraj',
    OL: 'Olomoucký kraj',
    PA: 'Pardubický kraj',
    PL: 'Plzeňský kraj',
    PR: 'Praha, hlavní mešto',
    ST: 'Středočeský kraj',
    US: 'Ústecký kraj',
    VY: 'Vysočina',
    ZL: 'Zlínský kraj',
  },
  DK: {
    '81': 'Nordjylland',
    '82': 'Midtjylland',
    '83': 'Syddanmark',
    '84': 'Hovedstaden',
    '85': 'Sjælland',
  },
  DJ: {
    AR: 'Arta',
    AS: 'Ali Sabieh',
    DI: 'Dikhīl',
    DJ: 'Djibouti',
    OB: 'Obock',
    TA: 'Tadjourah',
  },
  DM: {
    '10': 'Saint Paul',
    '11': 'Saint Peter',
    '02': 'Saint Andrew',
    '03': 'Saint David',
    '04': 'Saint George',
    '05': 'Saint John',
    '06': 'Saint Joseph',
    '07': 'Saint Luke',
    '08': 'Saint Mark',
    '09': 'Saint Patrick',
  },
  DO: {
    '10': 'Independencia',
    '11': 'La Altagracia',
    '12': 'La Romana',
    '13': 'La Vega',
    '14': 'María Trinidad Sánchez',
    '15': 'Monte Cristi',
    '16': 'Pedernales',
    '17': 'Peravia',
    '18': 'Puerto Plata',
    '19': 'Hermanas Mirabal',
    '20': 'Samaná',
    '21': 'San Cristóbal',
    '22': 'San Juan',
    '23': 'San Pedro de Macorís',
    '24': 'Sánchez Ramírez',
    '25': 'Santiago',
    '26': 'Santiago Rodríguez',
    '27': 'Valverde',
    '28': 'Monseñor Nouel',
    '29': 'Monte Plata',
    '30': 'Hato Mayor',
    '31': 'San José de Ocoa',
    '32': 'Santo Domingo',
    '33': 'Cibao Nordeste',
    '34': 'Cibao Noroeste',
    '35': 'Cibao Norte',
    '36': 'Cibao Sur',
    '37': 'El Valle',
    '38': 'Enriquillo',
    '39': 'Higuamo',
    '40': 'Ozama',
    '41': 'Valdesia',
    '42': 'Yuma',
    '01': 'Distrito Nacional',
    '02': 'Azua',
    '03': 'Baoruco',
    '04': 'Barahona',
    '05': 'Dajabón',
    '06': 'Duarte',
    '07': 'La Estrelleta',
    '08': 'El Seibo',
    '09': 'Espaillat',
  },
  EC: {
    A: 'Azuay',
    B: 'Bolívar',
    C: 'Carchi',
    D: 'Orellana',
    E: 'Esmeraldas',
    F: 'Cañar',
    G: 'Guayas',
    H: 'Chimborazo',
    I: 'Imbabura',
    L: 'Loja',
    M: 'Manabí',
    N: 'Napo',
    O: 'El Oro',
    P: 'Pichincha',
    R: 'Los Ríos',
    SD: 'Santo Domingo de los Tsáchilas',
    SE: 'Santa Elena',
    S: 'Morona-Santiago',
    T: 'Tungurahua',
    U: 'Sucumbíos',
    W: 'Galápagos',
    X: 'Cotopaxi',
    Y: 'Pastaza',
    Z: 'Zamora-Chinchipe',
  },
  EG: {
    ALX: 'Al Iskandarīyah',
    ASN: 'Aswān',
    AST: 'Asyūţ',
    BA: 'Al Baḩr al Aḩmar',
    BH: 'Al Buḩayrah',
    BNS: 'Banī Suwayf',
    C: 'Al Qāhirah',
    DK: 'Ad Daqahlīyah',
    DT: 'Dumyāţ',
    FYM: 'Al Fayyūm',
    GH: 'Al Gharbīyah',
    GZ: 'Al Jīzah',
    IS: "Al Ismā'īlīyah",
    JS: "Janūb Sīnā'",
    KB: 'Al Qalyūbīyah',
    KFS: 'Kafr ash Shaykh',
    KN: 'Qinā',
    LX: 'Al Uqşur',
    MN: 'Al Minyā',
    MNF: 'Al Minūfīyah',
    MT: 'Maţrūḩ',
    PTS: 'Būr Sa‘īd',
    SHG: 'Sūhāj',
    SHR: 'Ash Sharqīyah',
    SIN: "Shamāl Sīnā'",
    SUZ: 'As Suways',
    WAD: 'Al Wādī al Jadīd',
  },
  SV: {
    AH: 'Ahuachapán',
    CA: 'Cabañas',
    CH: 'Chalatenango',
    CU: 'Cuscatlán',
    LI: 'La Libertad',
    MO: 'Morazán',
    PA: 'La Paz',
    SA: 'Santa Ana',
    SM: 'San Miguel',
    SO: 'Sonsonate',
    SS: 'San Salvador',
    SV: 'San Vicente',
    UN: 'La Unión',
    US: 'Usulután',
  },
  GQ: {
    AN: 'Annobón',
    BN: 'Bioko Nord',
    BS: 'Bioko Sud',
    C: 'Região Continental',
    CS: 'Centro Sud',
    I: 'Região Insular',
    KN: 'Kié-Ntem',
    LI: 'Litoral',
    WN: 'Wele-Nzas',
  },
  ER: {
    AN: 'Ansabā',
    DK: 'Debubawi K’eyyĭḥ Baḥri',
    DU: 'Al Janūbī',
    GB: 'Gash-Barka',
    MA: 'Al Awsaţ',
    SK: 'Semienawi K’eyyĭḥ Baḥri',
  },
  EE: {
    '37': 'Harjumaa',
    '39': 'Hiiumaa',
    '44': 'Ida-Virumaa',
    '49': 'Jõgevamaa',
    '51': 'Järvamaa',
    '57': 'Läänemaa',
    '59': 'Lääne-Virumaa',
    '65': 'Põlvamaa',
    '67': 'Pärnumaa',
    '70': 'Raplamaa',
    '74': 'Saaremaa',
    '78': 'Tartumaa',
    '82': 'Valgamaa',
    '84': 'Viljandimaa',
    '86': 'Võrumaa',
  },
  ET: {
    AA: 'Addis Ababa',
    AF: 'Afar',
    AM: 'Amara',
    BE: 'Benshangul-Gumaz',
    DD: 'Dire Dawa',
    GA: 'Gambēla Hizboch',
    HA: 'Harari People',
    OR: 'Oromia',
    SN: 'Southern Nations, Nationalities and Peoples',
    SO: 'Somali',
    TI: 'Tigrai',
  },
  FK: {
    FK: 'Falkland Islands',
  },
  FO: {
    FO: 'Faroe Islands',
  },
  FJ: {
    '10': 'Namosi',
    '11': 'Ra',
    '12': 'Rewa',
    '13': 'Serua',
    '14': 'Tailevu',
    '01': 'Ba',
    '02': 'Bua',
    '03': 'Cakaudrove',
    '04': 'Kadavu',
    '05': 'Lau',
    '06': 'Lomaiviti',
    '07': 'Macuata',
    '08': 'Nadroga and Navosa',
    '09': 'Naitasiri',
    C: 'Central',
    E: 'Eastern',
    N: 'Northern',
    R: 'Rotuma',
    W: 'Western',
  },
  FI: {
    '10': 'Lappi',
    '11': 'Birkaland',
    '12': 'Österbotten',
    '13': 'Norra Karelen',
    '14': 'Norra Österbotten',
    '15': 'Norra Savolax',
    '16': 'Päijänne-Tavastland',
    '17': 'Satakunda',
    '18': 'Nyland',
    '19': 'Egentliga Finland',
    '01': 'Ahvenanmaan maakunta',
    '02': 'Etelä-Karjala',
    '03': 'Etelä-Pohjanmaa',
    '04': 'Etelä-Savo',
    '05': 'Kainuu',
    '06': 'Egentliga Tavastland',
    '07': 'Keski-Pohjanmaa',
    '08': 'Keski-Suomi',
    '09': 'Kymenlaakso',
  },
  FR: {
    '10': 'Aube',
    '11': 'Aude',
    '12': 'Aveyron',
    '13': 'Bouches-du-Rhône',
    '14': 'Calvados',
    '15': 'Cantal',
    '16': 'Charente',
    '17': 'Charente-Maritime',
    '18': 'Cher',
    '19': 'Corrèze',
    '21': "Côte-d'Or",
    '22': "Côtes-d'Armor",
    '23': 'Creuse',
    '24': 'Dordogne',
    '25': 'Doubs',
    '26': 'Drôme',
    '27': 'Eure',
    '28': 'Eure-et-Loir',
    '29': 'Finistère',
    '30': 'Gard',
    '31': 'Haute-Garonne',
    '32': 'Gers',
    '33': 'Gironde',
    '34': 'Hérault',
    '35': 'Ille-et-Vilaine',
    '36': 'Indre',
    '37': 'Indre-et-Loire',
    '38': 'Isère',
    '39': 'Jura',
    '40': 'Landes',
    '41': 'Loir-et-Cher',
    '42': 'Loire',
    '43': 'Haute-Loire',
    '44': 'Loire-Atlantique',
    '45': 'Loiret',
    '46': 'Lot',
    '47': 'Lot-et-Garonne',
    '48': 'Lozère',
    '49': 'Maine-et-Loire',
    '50': 'Manche',
    '51': 'Marne',
    '52': 'Haute-Marne',
    '53': 'Mayenne',
    '54': 'Meurthe-et-Moselle',
    '55': 'Meuse',
    '56': 'Morbihan',
    '57': 'Moselle',
    '58': 'Nièvre',
    '59': 'Nord',
    '60': 'Oise',
    '61': 'Orne',
    '62': 'Pas-de-Calais',
    '63': 'Puy-de-Dôme',
    '64': 'Pyrénées-Atlantiques',
    '65': 'Hautes-Pyrénées',
    '66': 'Pyrénées-Orientales',
    '67': 'Bas-Rhin',
    '68': 'Haut-Rhin',
    '69': 'Rhône',
    '70': 'Haute-Saône',
    '71': 'Saône-et-Loire',
    '72': 'Sarthe',
    '73': 'Savoie',
    '74': 'Haute-Savoie',
    '75': 'Paris',
    '76': 'Seine-Maritime',
    '77': 'Seine-et-Marne',
    '78': 'Yvelines',
    '79': 'Deux-Sèvres',
    '80': 'Somme',
    '81': 'Tarn',
    '82': 'Tarn-et-Garonne',
    '83': 'Var',
    '84': 'Vaucluse',
    '85': 'Vendée',
    '86': 'Vienne',
    '87': 'Haute-Vienne',
    '88': 'Vosges',
    '89': 'Yonne',
    '90': 'Territoire de Belfort',
    '91': 'Essonne',
    '92': 'Hauts-de-Seine',
    '93': 'Seine-Saint-Denis',
    '94': 'Val-de-Marne',
    '95': "Val-d'Oise",
    '01': 'Ain',
    '02': 'Aisne',
    '03': 'Allier',
    '04': 'Alpes-de-Haute-Provence',
    '05': 'Hautes-Alpes',
    '06': 'Alpes-Maritimes',
    '07': 'Ardèche',
    '08': 'Ardennes',
    '09': 'Ariège',
    '2A': 'Corse-du-Sud',
    '2B': 'Haute-Corse',
    A: 'Alsace',
    B: 'Aquitaine',
    BL: 'Saint-Barthélemy',
    C: 'Auvergne',
    CP: 'Clipperton',
    D: 'Bourgogne',
    E: 'Bretagne',
    F: 'Centre',
    G: 'Champagne-Ardenne',
    GF: 'Guyane',
    GP: 'Guadeloupe',
    H: 'Corse',
    I: 'Franche-Comté',
    J: 'Île-de-France',
    K: 'Languedoc-Roussillon',
    L: 'Limousin',
    MF: 'Saint-Martin',
    M: 'Lorraine',
    MQ: 'Martinique',
    NC: 'Nouvelle-Calédonie',
    N: 'Midi-Pyrénées',
    O: 'Nord-Pas-de-Calais',
    P: 'Basse-Normandie',
    PF: 'Polynésie française',
    PM: 'Saint-Pierre-et-Miquelon',
    Q: 'Haute-Normandie',
    RE: 'La Réunion',
    R: 'Pays-de-la-Loire',
    S: 'Picardie',
    TF: 'Terres australes françaises',
    T: 'Poitou-Charentes',
    U: "Provence-Alpes-Côte-d'Azur",
    V: 'Rhône-Alpes',
    WF: 'Wallis-et-Futuna',
    YT: 'Mayotte',
  },
  GF: {
    GF: 'French Guiana',
  },
  PF: {
    PF: 'French Polynesia',
  },
  TF: {
    TF: 'French Southern Territories',
  },
  GA: {
    '1': 'Estuaire',
    '2': 'Haut-Ogooué',
    '3': 'Moyen-Ogooué',
    '4': 'Ngounié',
    '5': 'Nyanga',
    '6': 'Ogooué-Ivindo',
    '7': 'Ogooué-Lolo',
    '8': 'Ogooué-Maritime',
    '9': 'Woleu-Ntem',
  },
  GM: {
    B: 'Banjul',
    L: 'Lower River',
    M: 'Central River',
    N: 'North Bank',
    U: 'Upper River',
    W: 'Western',
  },
  GE: {
    AB: 'Abkhazia',
    AJ: 'Ajaria',
    GU: 'Guria',
    IM: 'Imereti',
    KA: "K'akheti",
    KK: 'Kvemo Kartli',
    MM: 'Mtskheta-Mtianeti',
    RL: "Rach'a-Lechkhumi-Kvemo Svaneti",
    SJ: 'Samtskhe-Javakheti',
    SK: 'Shida Kartli',
    SZ: 'Samegrelo-Zemo Svaneti',
    TB: 'Tbilisi',
  },
  DE: {
    BB: 'Brandenburg',
    BE: 'Berlin',
    BW: 'Baden-Württemberg',
    BY: 'Bayern',
    HB: 'Bremen',
    HE: 'Hessen',
    HH: 'Hamburg',
    MV: 'Mecklenburg-Vorpommern',
    NI: 'Niedersachsen',
    NW: 'Nordrhein-Westfalen',
    RP: 'Rheinland-Pfalz',
    SH: 'Schleswig-Holstein',
    SL: 'Saarland',
    SN: 'Sachsen',
    ST: 'Sachsen-Anhalt',
    TH: 'Thüringen',
  },
  GH: {
    AA: 'Greater Accra',
    AH: 'Ashanti',
    BA: 'Brong-Ahafo',
    CP: 'Central',
    EP: 'Eastern',
    NP: 'Northern',
    TV: 'Volta',
    UE: 'Upper East',
    UW: 'Upper West',
    WP: 'Western',
  },
  GI: {
    GI: 'Gibraltar',
  },
  GR: {
    '11': 'Argolída',
    '12': 'Arkadía',
    '13': 'Achaḯa',
    '14': 'Ileía',
    '15': 'Korinthía',
    '16': 'Lakonía',
    '17': 'Messinía',
    '21': 'Zákynthos',
    '22': 'Kérkyra',
    '23': 'Kefallinía',
    '24': 'Lefkáda',
    '31': 'Árta',
    '32': 'Thesprotía',
    '33': 'Ioánnina',
    '34': 'Préveza',
    '41': 'Kardítsa',
    '42': 'Lárisa',
    '43': 'Magnisía',
    '44': 'Tríkala',
    '51': 'Grevená',
    '52': 'Dráma',
    '53': 'Imathía',
    '54': 'Thessaloníki',
    '55': 'Kavála',
    '56': 'Kastoriá',
    '57': 'Kilkís',
    '58': 'Kozáni',
    '59': 'Pélla',
    '61': 'Piería',
    '62': 'Sérres',
    '63': 'Flórina',
    '64': 'Chalkidikí',
    '69': 'Ágion Óros',
    '71': 'Évros',
    '72': 'Xánthi',
    '73': 'Rodópi',
    '81': 'Dodekánisa',
    '82': 'Kykládes',
    '83': 'Lésvos',
    '84': 'Sámos',
    '85': 'Chíos',
    '91': 'Irakleío',
    '92': 'Lasíthi',
    '93': 'Rethýmnis',
    '94': 'Chaniá',
    '01': 'Aitoloakarnanía',
    '03': 'Voiotía',
    '04': 'Évvoia',
    '05': 'Evrytanía',
    '06': 'Fthiótida',
    '07': 'Fokída',
    A1: 'Attikí',
    A: 'Anatolikí Makedonía kai Thráki',
    B: 'Kentrikí Makedonía',
    C: 'Dytikí Makedonía',
    D: 'Ípeiros',
    E: 'Thessalía',
    F: 'Ionía Nísia',
    G: 'Dytikí Elláda',
    H: 'Stereá Elláda',
    I: 'Attikí',
    J: 'Peloponnísos',
    K: 'Voreío Aigaío',
    L: 'Notío Aigaío',
    M: 'Krítí',
  },
  GL: {
    KU: 'Kommune Kujalleq',
    QA: 'Qaasuitsup Kommunia',
    QE: 'Qeqqata Kommunia',
    SM: 'Kommuneqarfik Sermersooq',
  },
  GD: {
    '10': 'Southern Grenadine Islands',
    '01': 'Saint Andrew',
    '02': 'Saint David',
    '03': 'Saint George',
    '04': 'Saint John',
    '05': 'Saint Mark',
    '06': 'Saint Patrick',
  },
  GP: {
    GP: 'Guadeloupe',
  },
  GU: {
    GU: 'Guam',
  },
  GT: {
    AV: 'Alta Verapaz',
    BV: 'Baja Verapaz',
    CM: 'Chimaltenango',
    CQ: 'Chiquimula',
    ES: 'Escuintla',
    GU: 'Guatemala',
    HU: 'Huehuetenango',
    IZ: 'Izabal',
    JA: 'Jalapa',
    JU: 'Jutiapa',
    PE: 'Petén',
    PR: 'El Progreso',
    QC: 'Quiché',
    QZ: 'Quetzaltenango',
    RE: 'Retalhuleu',
    SA: 'Sacatepéquez',
    SM: 'San Marcos',
    SO: 'Sololá',
    SR: 'Santa Rosa',
    SU: 'Suchitepéquez',
    TO: 'Totonicapán',
    ZA: 'Zacapa',
  },
  GG: {
    GG: 'Guernsey',
  },
  GW: {
    BA: 'Bafatá',
    BL: 'Bolama',
    BM: 'Biombo',
    BS: 'Bissau',
    CA: 'Cacheu',
    GA: 'Gabú',
    L: 'Leste',
    N: 'Norte',
    OI: 'Oio',
    QU: 'Quinara',
    S: 'Sul',
    TO: 'Tombali',
  },
  GN: {
    B: 'Boké',
    BE: 'Beyla',
    BF: 'Boffa',
    BK: 'Boké',
    C: 'Conakry',
    CO: 'Coyah',
    DB: 'Dabola',
    DI: 'Dinguiraye',
    D: 'Kindia',
    DL: 'Dalaba',
    DU: 'Dubréka',
    FA: 'Faranah',
    F: 'Faranah',
    FO: 'Forécariah',
    FR: 'Fria',
    GA: 'Gaoual',
    GU: 'Guékédou',
    KA: 'Kankan',
    KB: 'Koubia',
    KD: 'Kindia',
    KE: 'Kérouané',
    K: 'Kankan',
    KN: 'Koundara',
    KO: 'Kouroussa',
    KS: 'Kissidougou',
    LA: 'Labé',
    LE: 'Lélouma',
    L: 'Labé',
    LO: 'Lola',
    MC: 'Macenta',
    MD: 'Mandiana',
    ML: 'Mali',
    M: 'Mamou',
    MM: 'Mamou',
    N: 'Nzérékoré',
    NZ: 'Nzérékoré',
    PI: 'Pita',
    SI: 'Siguiri',
    TE: 'Télimélé',
    TO: 'Tougué',
    YO: 'Yomou',
  },
  GY: {
    BA: 'Barima-Waini',
    CU: 'Cuyuni-Mazaruni',
    DE: 'Demerara-Mahaica',
    EB: 'East Berbice-Corentyne',
    ES: 'Essequibo Islands-West Demerara',
    MA: 'Mahaica-Berbice',
    PM: 'Pomeroon-Supenaam',
    PT: 'Potaro-Siparuni',
    UD: 'Upper Demerara-Berbice',
    UT: 'Upper Takutu-Upper Essequibo',
  },
  HT: {
    AR: 'Artibonite',
    CE: 'Centre',
    GA: 'Grandans',
    ND: 'Nò',
    NE: 'Nòdès',
    NI: 'Nip',
    NO: 'Nòdwès',
    OU: 'Lwès',
    SD: 'Sid',
    SE: 'Sidès',
  },
  HM: {
    HM: 'Heard & McDonald Islands',
  },
  HN: {
    AT: 'Atlántida',
    CH: 'Choluteca',
    CL: 'Colón',
    CM: 'Comayagua',
    CP: 'Copán',
    CR: 'Cortés',
    EP: 'El Paraíso',
    FM: 'Francisco Morazán',
    GD: 'Gracias a Dios',
    IB: 'Islas de la Bahía',
    IN: 'Intibucá',
    LE: 'Lempira',
    LP: 'La Paz',
    OC: 'Ocotepeque',
    OL: 'Olancho',
    SB: 'Santa Bárbara',
    VA: 'Valle',
    YO: 'Yoro',
  },
  HK: {
    HK: 'Hong Kong',
  },
  HU: {
    BA: 'Baranya',
    BC: 'Békéscsaba',
    BE: 'Békés',
    BK: 'Bács-Kiskun',
    BU: 'Budapest',
    BZ: 'Borsod-Abaúj-Zemplén',
    CS: 'Csongrád',
    DE: 'Debrecen',
    DU: 'Dunaújváros',
    EG: 'Eger',
    ER: 'Érd',
    FE: 'Fejér',
    GS: 'Győr-Moson-Sopron',
    GY: 'Győr',
    HB: 'Hajdú-Bihar',
    HE: 'Heves',
    HV: 'Hódmezővásárhely',
    JN: 'Jász-Nagykun-Szolnok',
    KE: 'Komárom-Esztergom',
    KM: 'Kecskemét',
    KV: 'Kaposvár',
    MI: 'Miskolc',
    NK: 'Nagykanizsa',
    NO: 'Nógrád',
    NY: 'Nyíregyháza',
    PE: 'Pest',
    PS: 'Pécs',
    SD: 'Szeged',
    SF: 'Székesfehérvár',
    SH: 'Szombathely',
    SK: 'Szolnok',
    SN: 'Sopron',
    SO: 'Somogy',
    SS: 'Szekszárd',
    ST: 'Salgótarján',
    SZ: 'Szabolcs-Szatmár-Bereg',
    TB: 'Tatabánya',
    TO: 'Tolna',
    VA: 'Vas',
    VE: 'Veszprém',
    VM: 'Veszprém',
    ZA: 'Zala',
    ZE: 'Zalaegerszeg',
  },
  IS: {
    '0': 'Reykjavík',
    '1': 'Höfuðborgarsvæði utan Reykjavíkur',
    '2': 'Suðurnes',
    '3': 'Vesturland',
    '4': 'Vestfirðir',
    '5': 'Norðurland vestra',
    '6': 'Norðurland eystra',
    '7': 'Austurland',
    '8': 'Suðurland',
  },
  IN: {
    AN: 'Andaman and Nicobar Islands',
    AP: 'Andhra Pradesh',
    AR: 'Arunachal Pradesh',
    AS: 'Assam',
    BR: 'Bihar',
    CH: 'Chandigarh',
    CT: 'Chhattisgarh',
    DD: 'Daman and Diu',
    DL: 'Delhi',
    DN: 'Dadra and Nagar Haveli',
    GA: 'Goa',
    GJ: 'Gujarat',
    HP: 'Himachal Pradesh',
    HR: 'Haryana',
    JH: 'Jharkhand',
    JK: 'Jammu and Kashmir',
    KA: 'Karnataka',
    KL: 'Kerala',
    LD: 'Lakshadweep',
    MH: 'Maharashtra',
    ML: 'Meghalaya',
    MN: 'Manipur',
    MP: 'Madhya Pradesh',
    MZ: 'Mizoram',
    NL: 'Nagaland',
    OR: 'Odisha',
    PB: 'Punjab',
    PY: 'Puducherry',
    RJ: 'Rajasthan',
    SK: 'Sikkim',
    TG: 'Telangana',
    TN: 'Tamil Nadu',
    TR: 'Tripura',
    UP: 'Uttar Pradesh',
    UT: 'Uttarakhand',
    WB: 'West Bengal',
  },
  ID: {
    AC: 'Aceh',
    BA: 'Bali',
    BB: 'Bangka Belitung',
    BE: 'Bengkulu',
    BT: 'Banten',
    GO: 'Gorontalo',
    JA: 'Jambi',
    JB: 'Jawa Barat',
    JI: 'Jawa Timur',
    JK: 'Jakarta Raya',
    JT: 'Jawa Tengah',
    JW: 'Jawa',
    KA: 'Kalimantan',
    KB: 'Kalimantan Barat',
    KI: 'Kalimantan Timur',
    KR: 'Kepulauan Riau',
    KS: 'Kalimantan Selatan',
    KT: 'Kalimantan Tengah',
    KU: 'Kalimantan Utara',
    LA: 'Lampung',
    MA: 'Maluku',
    ML: 'Maluku',
    MU: 'Maluku Utara',
    NB: 'Nusa Tenggara Barat',
    NT: 'Nusa Tenggara Timur',
    NU: 'Nusa Tenggara',
    PA: 'Papua',
    PB: 'Papua Barat',
    PP: 'Papua',
    RI: 'Riau',
    SA: 'Sulawesi Utara',
    SB: 'Sumatera Barat',
    SG: 'Sulawesi Tenggara',
    SL: 'Sulawesi',
    SM: 'Sumatera',
    SN: 'Sulawesi Selatan',
    SR: 'Sulawesi Barat',
    SS: 'Sumatera Selatan',
    ST: 'Sulawesi Tengah',
    SU: 'Sumatera Utara',
    YO: 'Yogyakarta',
  },
  IR: {
    '10': 'Khūzestān',
    '11': 'Zanjān',
    '12': 'Semnān',
    '13': 'Sīstān va Balūchestān',
    '14': 'Fārs',
    '15': 'Kermān',
    '16': 'Kordestān',
    '17': 'Kermānshāh',
    '18': 'Kohgīlūyeh va Būyer Aḩmad',
    '19': 'Gīlān',
    '20': 'Lorestān',
    '21': 'Māzandarān',
    '22': 'Markazī',
    '23': 'Hormozgān',
    '24': 'Hamadān',
    '25': 'Yazd',
    '26': 'Qom',
    '27': 'Golestān',
    '28': 'Qazvīn',
    '29': 'Khorāsān-e Janūbī',
    '30': 'Khorāsān-e Razavī',
    '31': 'Khorāsān-e Shemālī',
    '32': 'Alborz',
    '01': 'Āz̄arbāyjān-e Sharqī',
    '02': 'Āz̄arbāyjān-e Gharbī',
    '03': 'Ardabīl',
    '04': 'Eşfahān',
    '05': 'Īlām',
    '06': 'Būshehr',
    '07': 'Tehrān',
    '08': 'Chahār Maḩāll va Bakhtīārī',
  },
  IQ: {
    AN: 'Al Anbār',
    AR: 'Arbīl',
    BA: 'Al Başrah',
    BB: 'Bābil',
    BG: 'Baghdād',
    DA: 'Dahūk',
    DI: 'Diyālá',
    DQ: 'Dhī Qār',
    KA: "Karbalā'",
    KI: 'Kirkūk',
    MA: 'Maysān',
    MU: 'Al Muthanná',
    NA: 'An Najaf',
    NI: 'Nīnawá',
    QA: 'Al Qādisīyah',
    SD: 'Şalāḩ ad Dīn',
    SU: 'As Sulaymānīyah',
    WA: 'Wāsiţ',
  },
  IE: {
    C: 'Connacht',
    CE: 'An Clár',
    CN: 'An Cabhán',
    CO: 'Corcaigh',
    CW: 'Carlow',
    D: 'Baile Átha Cliath',
    DL: 'Donegal',
    G: 'Gaillimh',
    KE: 'Cill Dara',
    KK: 'Cill Chainnigh',
    KY: 'Ciarraí',
    LD: 'An Longfort',
    LH: 'Louth',
    LK: 'Limerick',
    L: 'Laighin',
    LM: 'Leitrim',
    LS: 'Laois',
    M: 'An Mhumhain',
    MH: 'An Mhí',
    MN: 'Monaghan',
    MO: 'Maigh Eo',
    OY: 'Offaly',
    RN: 'Ros Comáin',
    SO: 'Sligeach',
    TA: 'Tiobraid Árann',
    U: 'Ulaidh',
    WD: 'Port Láirge',
    WH: 'An Iarmhí',
    WW: 'Cill Mhantáin',
    WX: 'Loch Garman',
  },
  IM: {
    IM: 'Isle of Main',
  },
  IL: {
    D: 'Southern District',
    HA: 'Haifa',
    JM: 'Jerusalem',
    M: 'Central District',
    TA: 'Tel Aviv',
    Z: 'Northern District',
  },
  IT: {
    '21': 'Piemonte',
    '23': "Val d'Aoste",
    '25': 'Lombardia',
    '32': 'Trentino-Alto Adige',
    '34': 'Veneto',
    '36': 'Friuli-Venezia Giulia',
    '42': 'Liguria',
    '45': 'Emilia-Romagna',
    '52': 'Toscana',
    '55': 'Umbria',
    '57': 'Marche',
    '62': 'Lazio',
    '65': 'Abruzzo',
    '67': 'Molise',
    '72': 'Campania',
    '75': 'Puglia',
    '77': 'Basilicata',
    '78': 'Calabria',
    '82': 'Sicilia',
    '88': 'Sardegna',
    AG: 'Agrigento',
    AL: 'Alessandria',
    AN: 'Ancona',
    AO: 'Aosta',
    AP: 'Ascoli Piceno',
    AQ: "L'Aquila",
    AR: 'Arezzo',
    AT: 'Asti',
    AV: 'Avellino',
    BA: 'Bari',
    BG: 'Bergamo',
    BI: 'Biella',
    BL: 'Belluno',
    BN: 'Benevento',
    BO: 'Bologna',
    BR: 'Brindisi',
    BS: 'Brescia',
    BT: 'Barletta-Andria-Trani',
    BZ: 'Bolzano',
    CA: 'Cagliari',
    CB: 'Campobasso',
    CE: 'Caserta',
    CH: 'Chieti',
    CI: 'Carbonia-Iglesias',
    CL: 'Caltanissetta',
    CN: 'Cuneo',
    CO: 'Como',
    CR: 'Cremona',
    CS: 'Cosenza',
    CT: 'Catania',
    CZ: 'Catanzaro',
    EN: 'Enna',
    FC: 'Forlì-Cesena',
    FE: 'Ferrara',
    FG: 'Foggia',
    FI: 'Firenze',
    FM: 'Fermo',
    FR: 'Frosinone',
    GE: 'Genova',
    GO: 'Gorizia',
    GR: 'Grosseto',
    IM: 'Imperia',
    IS: 'Isernia',
    KR: 'Crotone',
    LC: 'Lecco',
    LE: 'Lecce',
    LI: 'Livorno',
    LO: 'Lodi',
    LT: 'Latina',
    LU: 'Lucca',
    MB: 'Monza e Brianza',
    MC: 'Macerata',
    ME: 'Messina',
    MI: 'Milano',
    MN: 'Mantova',
    MO: 'Modena',
    MS: 'Massa-Carrara',
    MT: 'Matera',
    NA: 'Napoli',
    NO: 'Novara',
    NU: 'Nuoro',
    OG: 'Ogliastra',
    OR: 'Oristano',
    OT: 'Olbia-Tempio',
    PA: 'Palermo',
    PC: 'Piacenza',
    PD: 'Padova',
    PE: 'Pescara',
    PG: 'Perugia',
    PI: 'Pisa',
    PN: 'Pordenone',
    PO: 'Prato',
    PR: 'Parma',
    PT: 'Pistoia',
    PU: 'Pesaro e Urbino',
    PV: 'Pavia',
    PZ: 'Potenza',
    RA: 'Ravenna',
    RC: 'Reggio Calabria',
    RE: 'Reggio Emilia',
    RG: 'Ragusa',
    RI: 'Rieti',
    RM: 'Roma',
    RN: 'Rimini',
    RO: 'Rovigo',
    SA: 'Salerno',
    SI: 'Siena',
    SO: 'Sondrio',
    SP: 'La Spezia',
    SR: 'Siracusa',
    SS: 'Sassari',
    SV: 'Savona',
    TA: 'Taranto',
    TE: 'Teramo',
    TN: 'Trento',
    TO: 'Torino',
    TP: 'Trapani',
    TR: 'Terni',
    TS: 'Trieste',
    TV: 'Treviso',
    UD: 'Udine',
    VA: 'Varese',
    VB: 'Verbano-Cusio-Ossola',
    VC: 'Vercelli',
    VE: 'Venezia',
    VI: 'Vicenza',
    VR: 'Verona',
    VS: 'Medio Campidano',
    VT: 'Viterbo',
    VV: 'Vibo Valentia',
  },
  JM: {
    '10': 'Westmoreland',
    '11': 'Saint Elizabeth',
    '12': 'Manchester',
    '13': 'Clarendon',
    '14': 'Saint Catherine',
    '01': 'Kingston',
    '02': 'Saint Andrew',
    '03': 'Saint Thomas',
    '04': 'Portland',
    '05': 'Saint Mary',
    '06': 'Saint Ann',
    '07': 'Trelawny',
    '08': 'Saint James',
    '09': 'Hanover',
  },
  JP: {
    '10': 'Gunma',
    '11': 'Saitama',
    '12': 'Chiba',
    '13': 'Tôkyô',
    '14': 'Kanagawa',
    '15': 'Niigata',
    '16': 'Toyama',
    '17': 'Ishikawa',
    '18': 'Fukui',
    '19': 'Yamanashi',
    '20': 'Nagano',
    '21': 'Gifu',
    '22': 'Shizuoka',
    '23': 'Aichi',
    '24': 'Mie',
    '25': 'Shiga',
    '26': 'Kyoto',
    '27': 'Osaka',
    '28': 'Hyogo',
    '29': 'Nara',
    '30': 'Wakayama',
    '31': 'Tottori',
    '32': 'Shimane',
    '33': 'Okayama',
    '34': 'Hiroshima',
    '35': 'Yamaguchi',
    '36': 'Tokushima',
    '37': 'Kagawa',
    '38': 'Ehime',
    '39': 'Kochi',
    '40': 'Fukuoka',
    '41': 'Saga',
    '42': 'Nagasaki',
    '43': 'Kumamoto',
    '44': 'Oita',
    '45': 'Miyazaki',
    '46': 'Kagoshima',
    '47': 'Okinawa',
    '01': 'Hokkaido',
    '02': 'Aomori',
    '03': 'Iwate',
    '04': 'Miyagi',
    '05': 'Akita',
    '06': 'Yamagata',
    '07': 'Fukushima',
    '08': 'Ibaraki',
    '09': 'Tochigi',
  },
  JE: {
    JE: 'Jersey',
  },
  JO: {
    AJ: 'ʽAjlūn',
    AM: '‘Ammān',
    AQ: 'Al ʽAqabah',
    AT: 'Aţ Ţafīlah',
    AZ: "Az Zarqā'",
    BA: "Al Balqā'",
    IR: 'Irbid',
    JA: 'Jarash',
    KA: 'Al Karak',
    MA: 'Al Mafraq',
    MD: 'Mādabā',
    MN: "Ma'ān",
  },
  KZ: {
    AKM: "Akmolinskaja oblast'",
    AKT: "Aktjubinskaja oblast'",
    ALA: 'Almaty',
    ALM: "Almatinskaja oblast'",
    AST: 'Astana',
    ATY: 'Atyraū oblysy',
    KAR: "Karagandinskaja oblast'",
    KUS: "Kostanajskaja oblast'",
    KZY: "Kyzylordinskaja oblast'",
    MAN: 'Mangghystaū oblysy',
    PAV: 'Pavlodar oblysy',
    SEV: "Severo-Kazahstanskaja oblast'",
    VOS: 'Shyghys Qazaqstan oblysy',
    YUZ: "Južno-Kazahstanskaja oblast'",
    ZAP: 'Batys Qazaqstan oblysy',
    ZHA: "Žambylskaja oblast'",
  },
  KE: {
    '10': 'Kajiado',
    '11': 'Kakamega',
    '12': 'Kericho',
    '13': 'Kiambu',
    '14': 'Kilifi',
    '15': 'Kirinyaga',
    '16': 'Kisii',
    '17': 'Kisumu',
    '18': 'Kitui',
    '19': 'Kwale',
    '20': 'Laikipia',
    '21': 'Lamu',
    '22': 'Machakos',
    '23': 'Makueni',
    '24': 'Mandera',
    '25': 'Marsabit',
    '26': 'Meru',
    '27': 'Migori',
    '28': 'Mombasa',
    '29': "Murang'a",
    '30': 'Nairobi City',
    '31': 'Nakuru',
    '32': 'Nandi',
    '33': 'Narok',
    '34': 'Nyamira',
    '35': 'Nyandarua',
    '36': 'Nyeri',
    '37': 'Samburu',
    '38': 'Siaya',
    '39': 'Taita/Taveta',
    '40': 'Tana River',
    '41': 'Tharaka-Nithi',
    '42': 'Trans Nzoia',
    '43': 'Turkana',
    '44': 'Uasin Gishu',
    '45': 'Vihiga',
    '46': 'Wajir',
    '47': 'West Pokot',
    '01': 'Baringo',
    '02': 'Bomet',
    '03': 'Bungoma',
    '04': 'Busia',
    '05': 'Elgeyo/Marakwet',
    '06': 'Embu',
    '07': 'Garissa',
    '08': 'Homa Bay',
    '09': 'Isiolo',
  },
  KI: {
    G: 'Gilbert Islands',
    L: 'Line Islands',
    P: 'Phoenix Islands',
  },
  KP: {
    '10': 'Ryangkangto',
    '13': 'Nasǒn',
    '01': "P'yǒngyang",
    '02': "P'yǒngan-namdo",
    '03': "P'yǒngan-bukto",
    '04': 'Chagang-do',
    '05': 'Hwanghae-namdo',
    '06': 'Hwanghae-bukto',
    '07': 'Kangweonto',
    '08': 'Hamgyǒng-namdo',
    '09': 'Hamgyǒng-bukto',
  },
  KR: {
    '11': "Seoul-T'ǔkpyǒlshi",
    '26': "Busan Gwang'yeogsi",
    '27': "Daegu Gwang'yeogsi",
    '28': "Inch'ǒn-Kwangyǒkshi",
    '29': "Gwangju Gwang'yeogsi",
    '30': "Daejeon Gwang'yeogsi",
    '31': "Ulsan Gwang'yeogsi",
    '41': 'Gyeonggido',
    '42': "Gang'weondo",
    '43': "Ch'ungch'ǒngbuk-do",
    '44': "Ch'ungch'ǒngnam-do",
    '45': 'Chǒllabuk-do',
    '46': 'Chǒllanam-do',
    '47': 'Gyeongsangbugdo',
    '48': 'Gyeongsangnamdo',
    '49': 'Cheju-do',
    '50': 'Sejong',
  },
  KW: {
    AH: 'Al Aḩmadī',
    FA: 'Al Farwānīyah',
    HA: 'Ḩawallī',
    JA: 'Al Jahrā’',
    KU: 'Al Kuwayt',
    MU: 'Mubārak al Kabīr',
  },
  KG: {
    B: 'Batken',
    C: 'Chü',
    GB: 'Bishkek',
    GO: 'Gorod Oš',
    J: "Džalal-Abadskaja oblast'",
    N: 'Naryn',
    O: 'Osh',
    T: 'Talas',
    Y: "Issyk-Kul'skaja oblast'",
  },
  LA: {
    AT: 'Attapu',
    BK: 'Bokèo',
    BL: 'Bolikhamxai',
    CH: 'Champasak',
    HO: 'Houaphan',
    KH: 'Khammouan',
    LM: 'Louang Namtha',
    LP: 'Louangphabang',
    OU: 'Oudomsai',
    PH: 'Phôngsali',
    SL: 'Salavan',
    SV: 'Savannakhét',
    VI: 'Vientiane',
    VT: 'Vientiane',
    XA: 'Sayaboury',
    XE: 'Sékong',
    XI: 'Xiangkhouang',
    XN: 'Xaisômboun',
  },
  LV: {
    '100': 'Vaiņodes novads',
    '101': 'Valkas novads',
    '102': 'Varakļānu novads',
    '103': 'Vārkavas novads',
    '104': 'Vecpiebalgas novads',
    '105': 'Vecumnieku novads',
    '106': 'Ventspils novads',
    '107': 'Viesītes novads',
    '108': 'Viļakas novads',
    '109': 'Viļānu novads',
    '110': 'Zilupes novads',
    '001': 'Aglonas novads',
    '002': 'Aizkraukles novads',
    '003': 'Aizputes novads',
    '004': 'Aknīstes novads',
    '005': 'Alojas novads',
    '006': 'Alsungas novads',
    '007': 'Alūksnes novads',
    '008': 'Amatas novads',
    '009': 'Apes novads',
    '010': 'Auces novads',
    '011': 'Ādažu novads',
    '012': 'Babītes novads',
    '013': 'Baldones novads',
    '014': 'Baltinavas novads',
    '015': 'Balvu novads',
    '016': 'Bauskas novads',
    '017': 'Beverīnas novads',
    '018': 'Brocēnu novads',
    '019': 'Burtnieku novads',
    '020': 'Carnikavas novads',
    '021': 'Cesvaines novads',
    '022': 'Cēsu novads',
    '023': 'Ciblas novads',
    '024': 'Dagdas novads',
    '025': 'Daugavpils novads',
    '026': 'Dobeles novads',
    '027': 'Dundagas novads',
    '028': 'Durbes novads',
    '029': 'Engures novads',
    '030': 'Ērgļu novads',
    '031': 'Garkalnes novads',
    '032': 'Grobiņas novads',
    '033': 'Gulbenes novads',
    '034': 'Iecavas novads',
    '035': 'Ikšķiles novads',
    '036': 'Ilūkstes novads',
    '037': 'Inčukalna novads',
    '038': 'Jaunjelgavas novads',
    '039': 'Jaunpiebalgas novads',
    '040': 'Jaunpils novads',
    '041': 'Jelgavas novads',
    '042': 'Jēkabpils novads',
    '043': 'Kandavas novads',
    '044': 'Kārsavas novads',
    '045': 'Kocēnu novads',
    '046': 'Kokneses novads',
    '047': 'Krāslavas novads',
    '048': 'Krimuldas novads',
    '049': 'Krustpils novads',
    '050': 'Kuldīgas novads',
    '051': 'Ķeguma novads',
    '052': 'Ķekavas novads',
    '053': 'Lielvārdes novads',
    '054': 'Limbažu novads',
    '055': 'Līgatnes novads',
    '056': 'Līvānu novads',
    '057': 'Lubānas novads',
    '058': 'Ludzas novads',
    '059': 'Madonas novads',
    '060': 'Mazsalacas novads',
    '061': 'Mālpils novads',
    '062': 'Mārupes novads',
    '063': 'Mērsraga novads',
    '064': 'Naukšēnu novads',
    '065': 'Neretas novads',
    '066': 'Nīcas novads',
    '067': 'Ogres novads',
    '068': 'Olaines novads',
    '069': 'Ozolnieku novads',
    '070': 'Pārgaujas novads',
    '071': 'Pāvilostas novads',
    '072': 'Pļaviņu novads',
    '073': 'Preiļu novads',
    '074': 'Priekules novads',
    '075': 'Priekuļu novads',
    '076': 'Raunas novads',
    '077': 'Rēzeknes novads',
    '078': 'Riebiņu novads',
    '079': 'Rojas novads',
    '080': 'Ropažu novads',
    '081': 'Rucavas novads',
    '082': 'Rugāju novads',
    '083': 'Rundāles novads',
    '084': 'Rūjienas novads',
    '085': 'Salas novads',
    '086': 'Salacgrīvas novads',
    '087': 'Salaspils novads',
    '088': 'Saldus novads',
    '089': 'Saulkrastu novads',
    '090': 'Sējas novads',
    '091': 'Siguldas novads',
    '092': 'Skrīveru novads',
    '093': 'Skrundas novads',
    '094': 'Smiltenes novads',
    '095': 'Stopiņu novads',
    '096': 'Strenču novads',
    '097': 'Talsu novads',
    '098': 'Tērvetes novads',
    '099': 'Tukuma novads',
    DGV: 'Daugavpils',
    JEL: 'Jelgava',
    JKB: 'Jēkabpils',
    JUR: 'Jūrmala',
    LPX: 'Liepāja',
    REZ: 'Rēzekne',
    RIX: 'Rīga',
    VEN: 'Ventspils',
    VMR: 'Valmiera',
  },
  LB: {
    AK: 'Aakkâr',
    AS: 'Ash Shimāl',
    BA: 'Bayrūt',
    BH: 'Baalbek-Hermel',
    BI: 'Al Biqā‘',
    JA: 'Al Janūb',
    JL: 'Jabal Lubnān',
    NA: 'An Nabaţīyah',
  },
  LS: {
    A: 'Maseru',
    B: 'Butha-Buthe',
    C: 'Leribe',
    D: 'Berea',
    E: 'Mafeteng',
    F: "Mohale's Hoek",
    G: 'Quthing',
    H: "Qacha's Nek",
    J: 'Mokhotlong',
    K: 'Thaba-Tseka',
  },
  LR: {
    BG: 'Bong',
    BM: 'Bomi',
    CM: 'Grand Cape Mount',
    GB: 'Grand Bassa',
    GG: 'Grand Gedeh',
    GK: 'Grand Kru',
    GP: 'Gbarpolu',
    LO: 'Lofa',
    MG: 'Margibi',
    MO: 'Montserrado',
    MY: 'Maryland',
    NI: 'Nimba',
    RG: 'River Gee',
    RI: 'Rivercess',
    SI: 'Sinoe',
  },
  LY: {
    BA: 'Banghāzī',
    BU: 'Al Buţnān',
    DR: 'Darnah',
    GT: 'Ghāt',
    JA: 'Al Jabal al Akhḑar',
    JG: 'Al Jabal al Gharbī',
    JI: 'Al Jifārah',
    JU: 'Al Jufrah',
    KF: 'Al Kufrah',
    MB: 'Al Marqab',
    MI: 'Mişrātah',
    MJ: 'Al Marj',
    MQ: 'Murzuq',
    NL: 'Nālūt',
    NQ: 'An Nuqāţ al Khams',
    SB: 'Sabhā',
    SR: 'Surt',
    TB: 'Ţarābulus',
    WA: 'Al Wāḩāt',
    WD: 'Wādī al Ḩayāt',
    WS: 'Wādī ash Shāţi’',
    ZA: 'Az Zāwiyah',
  },
  LI: {
    '10': 'Triesenberg',
    '11': 'Vaduz',
    '01': 'Balzers',
    '02': 'Eschen',
    '03': 'Gamprin',
    '04': 'Mauren',
    '05': 'Planken',
    '06': 'Ruggell',
    '07': 'Schaan',
    '08': 'Schellenberg',
    '09': 'Triesen',
  },
  LT: {
    '10': 'Jonava',
    '11': 'Joniškis',
    '12': 'Jurbarkas',
    '13': 'Kaišiadorys',
    '14': 'Kalvarijos',
    '15': 'Kauno miestas',
    '16': 'Kaunas',
    '17': 'Kazlų Rūdos',
    '18': 'Kėdainiai',
    '19': 'Kelmė',
    '20': 'Klaipėdos miestas',
    '21': 'Klaipėda',
    '22': 'Kretinga',
    '23': 'Kupiškis',
    '24': 'Lazdijai',
    '25': 'Marijampolė',
    '26': 'Mažeikiai',
    '27': 'Molėtai',
    '28': 'Neringa',
    '29': 'Pagégiai',
    '30': 'Pakruojis',
    '31': 'Palangos miestas',
    '32': 'Panevėžio miestas',
    '33': 'Panevėžys',
    '34': 'Pasvalys',
    '35': 'Plungė',
    '36': 'Prienai',
    '37': 'Radviliškis',
    '38': 'Raseiniai',
    '39': 'Rietavo',
    '40': 'Rokiškis',
    '41': 'Šakiai',
    '42': 'Šalčininkai',
    '43': 'Šiaulių miestas',
    '44': 'Šiauliai',
    '45': 'Šilalė',
    '46': 'Šilutė',
    '47': 'Širvintos',
    '48': 'Skuodas',
    '49': 'Švenčionys',
    '50': 'Tauragė',
    '51': 'Telšiai',
    '52': 'Trakai',
    '53': 'Ukmergė',
    '54': 'Utena',
    '55': 'Varėna',
    '56': 'Vilkaviškis',
    '57': 'Vilniaus miestas',
    '58': 'Vilnius',
    '59': 'Visaginas',
    '60': 'Zarasai',
    '01': 'Akmenė',
    '02': 'Alytaus miestas',
    '03': 'Alytus',
    '04': 'Anykščiai',
    '05': 'Birštono',
    '06': 'Biržai',
    '07': 'Druskininkai',
    '08': 'Elektrénai',
    '09': 'Ignalina',
    AL: 'Alytaus apskritis',
    KL: 'Klaipėdos apskritis',
    KU: 'Kauno apskritis',
    MR: 'Marijampolės apskritis',
    PN: 'Panevėžio apskritis',
    SA: 'Šiaulių apskritis',
    TA: 'Tauragės apskritis',
    TE: 'Telšių apskritis',
    UT: 'Utenos apskritis',
    VL: 'Vilniaus apskritis',
  },
  LU: {
    D: 'Diekirch',
    G: 'Grevenmacher',
    L: 'Lëtzebuerg',
  },
  MO: {
    MO: 'Macau',
  },
  MK: {
    '10': 'Valandovo',
    '11': 'Vasilevo',
    '12': 'Vevčani',
    '13': 'Veles',
    '14': 'Vinica',
    '15': 'Vraneštica',
    '16': 'Vrapčište',
    '17': 'Gazi Baba †',
    '18': 'Gevgelija',
    '19': 'Gostivar',
    '20': 'Gradsko',
    '21': 'Debar',
    '22': 'Debarca',
    '23': 'Delčevo',
    '24': 'Demir Kapija',
    '25': 'Demir Hisar',
    '26': 'Dojran',
    '27': 'Dolneni',
    '28': 'Drugovo',
    '29': 'Gjorče Petrov †',
    '30': 'Želino',
    '31': 'Zajas',
    '32': 'Zelenikovo',
    '33': 'Zrnovci',
    '34': 'Ilinden',
    '35': 'Jegunovce',
    '36': 'Kavadarci',
    '37': 'Karbinci',
    '38': 'Karpoš †',
    '39': 'Kisela Voda †',
    '40': 'Kičevo',
    '41': 'Konče',
    '42': 'Kočani',
    '43': 'Kratovo',
    '44': 'Kriva Palanka',
    '45': 'Krivogaštani',
    '46': 'Kruševo',
    '47': 'Kumanovo',
    '48': 'Lipkovo',
    '49': 'Lozovo',
    '50': 'Mavrovo i Rostuša',
    '51': 'Makedonska Kamenica',
    '52': 'Makedonski Brod',
    '53': 'Mogila',
    '54': 'Negotino',
    '55': 'Novaci',
    '56': 'Novo Selo',
    '57': 'Oslomej',
    '58': 'Ohrid',
    '59': 'Petrovec',
    '60': 'Pehčevo',
    '61': 'Plasnica',
    '62': 'Prilep',
    '63': 'Probištip',
    '64': 'Radoviš',
    '65': 'Rankovce',
    '66': 'Resen',
    '67': 'Rosoman',
    '68': 'Saraj †',
    '69': 'Sveti Nikole',
    '70': 'Sopište',
    '71': 'Staro Nagoričane',
    '72': 'Struga',
    '73': 'Strumica',
    '74': 'Studeničani',
    '75': 'Tearce',
    '76': 'Tetovo',
    '77': 'Centar †',
    '78': 'Centar Župa',
    '79': 'Čair †',
    '80': 'Čaška',
    '81': 'Češinovo-Obleševo',
    '82': 'Čučer Sandevo',
    '83': 'Štip',
    '84': 'Šuto Orizari †',
    '01': 'Aerodrom †',
    '02': 'Aračinovo',
    '03': 'Berovo',
    '04': 'Bitola',
    '05': 'Bogdanci',
    '06': 'Bogovinje',
    '07': 'Bosilovo',
    '08': 'Brvenica',
    '09': 'Butel †',
  },
  MG: {
    A: 'Toamasina',
    D: 'Antsiranana',
    F: 'Fianarantsoa',
    M: 'Mahajanga',
    T: 'Antananarivo',
    U: 'Toliara',
  },
  MW: {
    BA: 'Balaka',
    BL: 'Blantyre',
    C: 'Central Region',
    CK: 'Chikwawa',
    CR: 'Chiradzulu',
    CT: 'Chitipa',
    DE: 'Dedza',
    DO: 'Dowa',
    KR: 'Karonga',
    KS: 'Kasungu',
    LI: 'Lilongwe',
    LK: 'Likoma',
    MC: 'Mchinji',
    MG: 'Mangochi',
    MH: 'Machinga',
    MU: 'Mulanje',
    MW: 'Mwanza',
    MZ: 'Mzimba',
    NB: 'Nkhata Bay',
    N: 'Chakumpoto',
    NE: 'Neno',
    NI: 'Ntchisi',
    NK: 'Nkhotakota',
    NS: 'Nsanje',
    NU: 'Ntcheu',
    PH: 'Phalombe',
    RU: 'Rumphi',
    SA: 'Salima',
    S: 'Chakumwera',
    TH: 'Thyolo',
    ZO: 'Zomba',
  },
  MY: {
    '10': 'Selangor',
    '11': 'Terengganu',
    '12': 'Sabah',
    '13': 'Sarawak',
    '14': 'Wilayah Persekutuan Kuala Lumpur',
    '15': 'Wilayah Persekutuan Labuan',
    '16': 'Wilayah Persekutuan Putrajaya',
    '01': 'Johor',
    '02': 'Kedah',
    '03': 'Kelantan',
    '04': 'Melaka',
    '05': 'Negeri Sembilan',
    '06': 'Pahang',
    '07': 'Pulau Pinang',
    '08': 'Perak',
    '09': 'Perlis',
  },
  MV: {
    '12': 'Meemu',
    '13': 'Maalhosmadulu Uthuruburi',
    '14': 'Faafu',
    '17': 'Dhaalu',
    '20': 'Baa',
    '23': 'Haa Dhaalu',
    '24': 'Miladhunmadulu Uthuruburi',
    '25': 'Miladhunmadulu Dhekunuburi',
    '26': 'Kaafu',
    '27': 'Gaafu Alifu',
    '28': 'Gaafu Dhaalu',
    '29': 'Fuvammulah',
    '00': 'Alifu Dhaalu',
    '01': 'Addu Atholhu',
    '02': 'Alifu Alifu',
    '03': 'Faadhippolhu',
    '04': 'Felidhu Atholhu',
    '05': 'Hadhdhunmathi',
    '07': 'Haa Alifu',
    '08': 'Kolhumadulu',
    CE: 'Central',
    MLE: 'Maale',
    NC: 'Medhu-Uthuru',
    NO: 'North',
    SC: 'Medhu-Dhekunu',
    SU: 'Dhekunu',
    UN: 'Mathi-Uthuru',
    US: 'Mathi-Dhekunu',
  },
  ML: {
    '1': 'Kayes',
    '2': 'Koulikoro',
    '3': 'Sikasso',
    '4': 'Ségou',
    '5': 'Mopti',
    '6': 'Tombouctou',
    '7': 'Gao',
    '8': 'Kidal',
    BKO: 'Bamako',
  },
  MT: {
    '10': 'Fontana',
    '11': 'Gudja',
    '12': 'Gżira',
    '13': 'Għajnsielem',
    '14': 'Għarb',
    '15': 'Għargħur',
    '16': 'Għasri',
    '17': 'Għaxaq',
    '18': 'Ħamrun',
    '19': 'Iklin',
    '20': 'Isla',
    '21': 'Kalkara',
    '22': 'Kerċem',
    '23': 'Kirkop',
    '24': 'Lija',
    '25': 'Luqa',
    '26': 'Marsa',
    '27': 'Marsaskala',
    '28': 'Marsaxlokk',
    '29': 'Mdina',
    '30': 'Mellieħa',
    '31': 'Mġarr',
    '32': 'Mosta',
    '33': 'Mqabba',
    '34': 'Msida',
    '35': 'Mtarfa',
    '36': 'Munxar',
    '37': 'Nadur',
    '38': 'Naxxar',
    '39': 'Paola',
    '40': 'Pembroke',
    '41': 'Pietà',
    '42': 'Qala',
    '43': 'Qormi',
    '44': 'Qrendi',
    '45': 'Rabat Gozo',
    '46': 'Rabat Malta',
    '47': 'Safi',
    '48': 'Saint Julian’s',
    '49': 'Saint John',
    '50': 'Saint Lawrence',
    '51': 'Saint Paul’s Bay',
    '52': 'Sannat',
    '53': 'Saint Lucia’s',
    '54': 'Santa Venera',
    '55': 'Siġġiewi',
    '56': 'Sliema',
    '57': 'Swieqi',
    '58': 'Ta’ Xbiex',
    '59': 'Tarxien',
    '60': 'Valletta',
    '61': 'Xagħra',
    '62': 'Xewkija',
    '63': 'Xgħajra',
    '64': 'Żabbar',
    '65': 'Żebbuġ Gozo',
    '66': 'Żebbuġ Malta',
    '67': 'Żejtun',
    '68': 'Żurrieq',
    '01': 'Attard',
    '02': 'Balzan',
    '03': 'Birgu',
    '04': 'Birkirkara',
    '05': 'Birżebbuġa',
    '06': 'Bormla',
    '07': 'Dingli',
    '08': 'Fgura',
    '09': 'Floriana',
  },
  MH: {
    ALK: 'Ailuk',
    ALL: 'Ailinglaplap',
    ARN: 'Arno',
    AUR: 'Aur',
    EBO: 'Ebon',
    ENI: 'Enewetak and Ujelang',
    JAB: 'Jabat',
    JAL: 'Jaluit',
    KIL: 'Bikini and Kili',
    KWA: 'Kwajalein',
    LAE: 'Lae',
    LIB: 'Lib',
    LIK: 'Likiep',
    L: 'Ralik chain',
    MAJ: 'Majuro',
    MAL: 'Maloelap',
    MEJ: 'Mejit',
    MIL: 'Mili',
    NMK: 'Namdrik',
    NMU: 'Namu',
    RON: 'Rongelap',
    T: 'Ratak chain',
    UJA: 'Ujae',
    UTI: 'Utrik',
    WTH: 'Wotho',
    WTJ: 'Wotje',
  },
  MQ: {
    MQ: 'Martinique',
  },
  MR: {
    '10': 'Guidimaka',
    '11': 'Tiris Zemmour',
    '12': 'Inchiri',
    '01': 'Hodh ech Chargui',
    '02': 'Hodh el Gharbi',
    '03': 'Assaba',
    '04': 'Gorgol',
    '05': 'Brakna',
    '06': 'Trarza',
    '07': 'Adrar',
    '08': 'Dakhlet Nouâdhibou',
    '09': 'Tagant',
    NKC: 'Nouakchott',
  },
  MU: {
    AG: 'Agalega Islands',
    BL: 'Black River',
    BR: 'Beau Bassin-Rose Hill',
    CC: 'Cargados Carajos Shoals',
    CU: 'Curepipe',
    FL: 'Flacq',
    GP: 'Grand Port',
    MO: 'Moka',
    PA: 'Pamplemousses',
    PL: 'Port Louis',
    PU: 'Port Louis',
    PW: 'Plaines Wilhems',
    QB: 'Quatre Bornes',
    RO: 'Rodrigues Island',
    RR: 'Rivière du Rempart',
    SA: 'Savanne',
    VP: 'Vacoas-Phoenix',
  },
  YT: {
    YT: 'Mayotte',
  },
  MX: {
    AGU: 'Aguascalientes',
    BCN: 'Baja California',
    BCS: 'Baja California Sur',
    CAM: 'Campeche',
    CHH: 'Chihuahua',
    CHP: 'Chiapas',
    COA: 'Coahuila de Zaragoza',
    COL: 'Colima',
    CMX: 'Ciudad de México',
    DUR: 'Durango',
    GRO: 'Guerrero',
    GUA: 'Guanajuato',
    HID: 'Hidalgo',
    JAL: 'Jalisco',
    MEX: 'México',
    MIC: 'Michoacán de Ocampo',
    MOR: 'Morelos',
    NAY: 'Nayarit',
    NLE: 'Nuevo León',
    OAX: 'Oaxaca',
    PUE: 'Puebla',
    QUE: 'Querétaro',
    ROO: 'Quintana Roo',
    SIN: 'Sinaloa',
    SLP: 'San Luis Potosí',
    SON: 'Sonora',
    TAB: 'Tabasco',
    TAM: 'Tamaulipas',
    TLA: 'Tlaxcala',
    VER: 'Veracruz de Ignacio de la Llave',
    YUC: 'Yucatán',
    ZAC: 'Zacatecas',
  },
  FM: {
    KSA: 'Kosrae',
    PNI: 'Pohnpei',
    TRK: 'Chuuk',
    YAP: 'Yap',
  },
  MD: {
    AN: 'Anenii Noi',
    BA: 'Bălţi',
    BD: 'Bender',
    BR: 'Briceni',
    BS: 'Basarabeasca',
    CA: 'Cahul',
    CL: 'Călăraşi',
    CM: 'Cimişlia',
    CR: 'Criuleni',
    CS: 'Căuşeni',
    CT: 'Cantemir',
    CU: 'Chişinău',
    DO: 'Donduşeni',
    DR: 'Drochia',
    DU: 'Dubăsari',
    ED: 'Edineţ',
    FA: 'Făleşti',
    FL: 'Floreşti',
    GA: 'Găgăuzia, Unitatea teritorială autonomă',
    GL: 'Glodeni',
    HI: 'Hînceşti',
    IA: 'Ialoveni',
    LE: 'Leova',
    NI: 'Nisporeni',
    OC: 'Ocniţa',
    OR: 'Orhei',
    RE: 'Rezina',
    RI: 'Rîşcani',
    SD: 'Şoldăneşti',
    SI: 'Sîngerei',
    SN: 'Stînga Nistrului, unitatea teritorială din',
    SO: 'Soroca',
    ST: 'Străşeni',
    SV: 'Ştefan Vodă',
    TA: 'Taraclia',
    TE: 'Teleneşti',
    UN: 'Ungheni',
  },
  MC: {
    CL: 'La Colle',
    CO: 'La Condamine',
    FO: 'Fontvieille',
    GA: 'La Gare',
    JE: 'Jardin Exotique',
    LA: 'Larvotto',
    MA: 'Malbousquet',
    MC: 'Monte-Carlo',
    MG: 'Moneghetti',
    MO: 'Monaco-Ville',
    MU: 'Moulins',
    PH: 'Port-Hercule',
    SD: 'Sainte-Dévote',
    SO: 'La Source',
    SP: 'Spélugues',
    SR: 'Saint-Roman',
    VR: 'Vallon de la Rousse',
  },
  MN: {
    '1': 'Ulaanbaatar',
    '035': 'Orhon',
    '037': 'Darhan uul',
    '039': 'Hentiy',
    '041': 'Hövsgöl',
    '043': 'Hovd',
    '046': 'Uvs',
    '047': 'Töv',
    '049': 'Selenge',
    '051': 'Sühbaatar',
    '053': 'Ömnögovĭ',
    '055': 'Övörhangay',
    '057': 'Dzavhan',
    '059': 'Dundgovĭ',
    '061': 'Dornod',
    '063': 'Dornogovĭ',
    '064': 'Govĭ-Sümber',
    '065': 'Govĭ-Altay',
    '067': 'Bulgan',
    '069': 'Bayanhongor',
    '071': 'Bayan-Ölgiy',
    '073': 'Arhangay',
  },
  ME: {
    '10': 'Kotor',
    '11': 'Mojkovac',
    '12': 'Nikšić',
    '13': 'Plav',
    '14': 'Pljevlja',
    '15': 'Plužine',
    '16': 'Podgorica',
    '17': 'Rožaje',
    '18': 'Šavnik',
    '19': 'Tivat',
    '20': 'Ulcinj',
    '21': 'Žabljak',
    '22': 'Gusinje',
    '23': 'Petnjica',
    '01': 'Andrijevica',
    '02': 'Bar',
    '03': 'Berane',
    '04': 'Bijelo Polje',
    '05': 'Budva',
    '06': 'Cetinje',
    '07': 'Danilovgrad',
    '08': 'Herceg-Novi',
    '09': 'Kolašin',
  },
  MS: {
    MS: 'Montserrat',
  },
  MA: {
    '10': 'Doukkala-Abda',
    '11': 'Marrakech-Tensift-Al Haouz',
    '12': 'Tadla-Azilal',
    '13': 'Sous-Massa-Draa',
    '14': 'Guelmim-Es Semara',
    '15': 'Laâyoune-Boujdour-Sakia el Hamra',
    '16': 'Oued ed Dahab-Lagouira',
    '01': 'Tanger-Tétouan',
    '02': 'Gharb-Chrarda-Beni Hssen',
    '03': 'Taza-Al Hoceima-Taounate',
    '04': "L'Oriental",
    '05': 'Fès-Boulemane',
    '06': 'Meknès-Tafilalet',
    '07': 'Rabat-Salé-Zemmour-Zaer',
    '08': 'Grand Casablanca',
    '09': 'Chaouia-Ouardigha',
    AGD: 'Agadir-Ida-Outanane',
    AOU: 'Aousserd',
    ASZ: 'Assa-Zag',
    AZI: 'Azilal',
    BEM: 'Beni Mellal',
    BER: 'Berkane',
    BES: 'Ben Slimane',
    BOD: 'Boujdour',
    BOM: 'Boulemane',
    CAS: 'Casablanca',
    CHE: 'Chefchaouen',
    CHI: 'Chichaoua',
    CHT: 'Chtouka-Ait Baha',
    ERR: 'Errachidia',
    ESI: 'Essaouira',
    ESM: 'Es Smara',
    FAH: 'Fahs-Beni Makada',
    FES: 'Fès-Dar-Dbibegh',
    FIG: 'Figuig',
    GUE: 'Guelmim',
    HAJ: 'El Hajeb',
    HAO: 'Al Haouz',
    HOC: 'Al Hoceïma',
    IFR: 'Ifrane',
    INE: 'Inezgane-Ait Melloul',
    JDI: 'El Jadida',
    JRA: 'Jrada',
    KEN: 'Kénitra',
    KES: 'Kelaat es Sraghna',
    KHE: 'Khemisset',
    KHN: 'Khenifra',
    KHO: 'Khouribga',
    LAA: 'Laâyoune',
    LAR: 'Larache',
    MED: 'Médiouna',
    MEK: 'Meknès',
    MMD: 'Marrakech-Medina',
    MMN: 'Marrakech-Menara',
    MOH: 'Mohammadia',
    MOU: 'Moulay Yacoub',
    NAD: 'Nador',
    NOU: 'Nouaceur',
    OUA: 'Ouarzazate',
    OUD: 'Oued ed Dahab',
    OUJ: 'Oujda-Angad',
    RAB: 'Rabat',
    SAF: 'Safi',
    SAL: 'Salé',
    SEF: 'Sefrou',
    SET: 'Settat',
    SIK: 'Sidi Kacem',
    SKH: 'Skhirate-Témara',
    SYB: 'Sidi Youssef Ben Ali',
    TAI: 'Taourirt',
    TAO: 'Taounate',
    TAR: 'Taroudant',
    TAT: 'Tata',
    TAZ: 'Taza',
    TET: 'Tétouan',
    TIZ: 'Tiznit',
    TNG: 'Tanger-Assilah',
    TNT: 'Tan-Tan',
    ZAG: 'Zagora',
  },
  MZ: {
    A: 'Niassa',
    B: 'Manica',
    G: 'Gaza',
    I: 'Inhambane',
    L: 'Maputo',
    MPM: 'Maputo',
    N: 'Nampula',
    P: 'Cabo Delgado',
    Q: 'Zambézia',
    S: 'Sofala',
    T: 'Tete',
  },
  MM: {
    '11': 'Kachin',
    '12': 'Kayah',
    '13': 'Kayin',
    '14': 'Chin',
    '15': 'Mon',
    '16': 'Rakhine',
    '17': 'Shan',
    '18': 'Nay Pyi Taw',
    '01': 'Sagaing',
    '02': 'Bago',
    '03': 'Magway',
    '04': 'Mandalay',
    '05': 'Taninthayi',
    '06': 'Yangon',
    '07': 'Ayeyawady',
  },
  NA: {
    CA: 'Zambezi',
    ER: 'Erongo',
    HA: 'Hardap',
    KA: 'Karas',
    KE: 'Kavango East',
    KH: 'Khomas',
    KU: 'Kunene',
    KW: 'Kavango West',
    OD: 'Otjozondjupa',
    OH: 'Omaheke',
    ON: 'Oshana',
    OS: 'Omusati',
    OT: 'Oshikoto',
    OW: 'Ohangwena',
  },
  NR: {
    '10': 'Ijuw',
    '11': 'Meneng',
    '12': 'Nibok',
    '13': 'Uaboe',
    '14': 'Yaren',
    '01': 'Aiwo',
    '02': 'Anabar',
    '03': 'Anetan',
    '04': 'Anibare',
    '05': 'Baiti',
    '06': 'Boe',
    '07': 'Buada',
    '08': 'Denigomodu',
    '09': 'Ewa',
  },
  NP: {
    '1': 'Central',
    '2': 'Madhya Pashchimanchal',
    '3': 'Pashchimanchal',
    '4': 'Eastern',
    '5': 'Far Western',
    BA: 'Bagmati',
    BH: 'Bheri',
    DH: 'Dhawalagiri',
    GA: 'Gandaki',
    JA: 'Janakpur',
    KA: 'Karnali',
    KO: 'Kosi',
    LU: 'Lumbini',
    MA: 'Mahakali',
    ME: 'Mechi',
    NA: 'Narayani',
    RA: 'Rapti',
    SA: 'Sagarmatha',
    SE: 'Seti',
  },
  NL: {
    AW: 'Aruba',
    BQ1: 'Bonaire',
    BQ2: 'Saba',
    BQ3: 'Sint Eustatius',
    CW: 'Curaçao',
    DR: 'Drenthe',
    FL: 'Flevoland',
    FR: 'Fryslân',
    GE: 'Gelderland',
    GR: 'Groningen',
    LI: 'Limburg',
    NB: 'Noord-Brabant',
    NH: 'Noord-Holland',
    OV: 'Overijssel',
    SX: 'Sint Maarten',
    UT: 'Utrecht',
    ZE: 'Zeeland',
    ZH: 'Zuid-Holland',
  },
  NC: {
    NC: 'New Caledonia',
  },
  NZ: {
    AUK: 'Auckland',
    BOP: 'Bay of Plenty',
    CAN: 'Canterbury',
    CIT: 'Chatham Islands Territory',
    GIS: 'Gisborne District',
    HKB: "Hawke's Bay",
    MBH: 'Marlborough District',
    MWT: 'Manawatu-Wanganui',
    N: 'North Island',
    NSN: 'Nelson City',
    NTL: 'Northland',
    OTA: 'Otago',
    S: 'South Island',
    STL: 'Southland',
    TAS: 'Tasman District',
    TKI: 'Taranaki',
    WGN: 'Wellington',
    WKO: 'Waikato',
    WTC: 'West Coast',
  },
  NI: {
    AN: 'Atlántico Norte',
    AS: 'Atlántico Sur',
    BO: 'Boaco',
    CA: 'Carazo',
    CI: 'Chinandega',
    CO: 'Chontales',
    ES: 'Estelí',
    GR: 'Granada',
    JI: 'Jinotega',
    LE: 'León',
    MD: 'Madriz',
    MN: 'Managua',
    MS: 'Masaya',
    MT: 'Matagalpa',
    NS: 'Nueva Segovia',
    RI: 'Rivas',
    SJ: 'Río San Juan',
  },
  NG: {
    AB: 'Abia',
    AD: 'Adamawa',
    AK: 'Akwa Ibom',
    AN: 'Anambra',
    BA: 'Bauchi',
    BE: 'Benue',
    BO: 'Borno',
    BY: 'Bayelsa',
    CR: 'Cross River',
    DE: 'Delta',
    EB: 'Ebonyi',
    ED: 'Edo',
    EK: 'Ekiti',
    EN: 'Enugu',
    FC: 'Abuja Federal Capital Territory',
    GO: 'Gombe',
    IM: 'Imo',
    JI: 'Jigawa',
    KD: 'Kaduna',
    KE: 'Kebbi',
    KN: 'Kano',
    KO: 'Kogi',
    KT: 'Katsina',
    KW: 'Kwara',
    LA: 'Lagos',
    NA: 'Nasarawa',
    NI: 'Niger',
    OG: 'Ogun',
    ON: 'Ondo',
    OS: 'Osun',
    OY: 'Oyo',
    PL: 'Plateau',
    RI: 'Rivers',
    SO: 'Sokoto',
    TA: 'Taraba',
    YO: 'Yobe',
    ZA: 'Zamfara',
  },
  NE: {
    '1': 'Agadez',
    '2': 'Diffa',
    '3': 'Dosso',
    '4': 'Maradi',
    '5': 'Tahoua',
    '6': 'Tillabéri',
    '7': 'Zinder',
    '8': 'Niamey',
  },
  NU: {
    NU: 'Niue',
  },
  NF: {
    NF: 'Norfolk Island',
  },
  MP: {
    MP: 'Northern Mariana Islands',
  },
  NO: {
    '10': 'Vest-Agder',
    '11': 'Rogaland',
    '12': 'Hordaland',
    '14': 'Sogn og Fjordane',
    '15': 'Møre og Romsdal',
    '16': 'Sør-Trøndelag',
    '17': 'Nord-Trøndelag',
    '18': 'Nordland',
    '19': 'Romsa',
    '20': 'Finnmark',
    '21': 'Svalbard',
    '22': 'Jan Mayen',
    '01': 'Østfold',
    '02': 'Akershus',
    '03': 'Oslo',
    '04': 'Hedmark',
    '05': 'Oppland',
    '06': 'Buskerud',
    '07': 'Vestfold',
    '08': 'Telemark',
    '09': 'Aust-Agder',
  },
  OM: {
    BA: 'Al Bāţinah',
    BU: 'Al Buraymī',
    DA: 'Ad Dākhilīyah',
    MA: 'Masqaţ',
    MU: 'Musandam',
    SH: 'Ash Sharqīyah',
    WU: 'Al Wusţá',
    ZA: 'Az̧ Z̧āhirah',
    ZU: 'Z̧ufār',
  },
  PK: {
    BA: 'Balochistan',
    GB: 'Gilgit-Baltistān',
    IS: 'Islāmābād',
    JK: 'Azad Kashmir',
    KP: 'Khaībar Pakhtūnkhwā',
    PB: 'Panjāb',
    SD: 'Sindh',
    TA: 'Federally Administered Tribal Areas',
  },
  PW: {
    '100': 'Kayangel',
    '150': 'Koror',
    '212': 'Melekeok',
    '214': 'Ngaraard',
    '218': 'Ngarchelong',
    '222': 'Ngardmau',
    '224': 'Ngatpang',
    '226': 'Ngchesar',
    '227': 'Ngeremlengui',
    '228': 'Ngiwal',
    '350': 'Peleliu',
    '370': 'Sonsorol',
    '002': 'Aimeliik',
    '004': 'Airai',
    '010': 'Angaur',
    '050': 'Hatobohei',
  },
  PS: {
    BTH: 'Bayt Laḩm',
    DEB: 'Dayr al Balaḩ',
    GZA: 'Gaza',
    HBN: 'Al Khalīl',
    JEM: 'Al Quds',
    JEN: 'Janīn',
    JRH: 'Arīḩā wa al Aghwār',
    KYS: 'Khan Yunis',
    NBS: 'Nablus',
    NGZ: 'North Gaza',
    QQA: 'Qalqilya',
    RBH: 'Ramallah',
    RFH: 'Rafah',
    SLT: 'Salfit',
    TBS: 'Tubas',
    TKM: 'Tulkarm',
  },
  PA: {
    '1': 'Bocas del Toro',
    '2': 'Coclé',
    '3': 'Colón',
    '4': 'Chiriquí',
    '5': 'Darién',
    '6': 'Herrera',
    '7': 'Los Santos',
    '8': 'Panamá',
    '9': 'Veraguas',
    '10': 'Panamá Oeste',
    EM: 'Emberá',
    KY: 'Kuna Yala',
    NB: 'Ngöbe-Buglé',
  },
  PG: {
    CPK: 'Chimbu',
    CPM: 'Central',
    EBR: 'East New Britain',
    EHG: 'Eastern Highlands',
    EPW: 'Enga',
    ESW: 'East Sepik',
    GPK: 'Gulf',
    HLA: 'Hela',
    JWK: 'Jiwaka',
    MBA: 'Milne Bay',
    MPL: 'Morobe',
    MPM: 'Madang',
    MRL: 'Manus',
    NCD: 'National Capital District',
    NIK: 'New Ireland',
    NPP: 'Northern',
    NSB: 'Bougainville',
    SAN: 'West Sepik',
    SHM: 'Southern Highlands',
    WBK: 'West New Britain',
    WHM: 'Western Highlands',
    WPD: 'Western',
  },
  PY: {
    '1': 'Concepción',
    '2': 'San Pedro',
    '3': 'Cordillera',
    '4': 'Guairá',
    '5': 'Caaguazú',
    '6': 'Caazapá',
    '7': 'Itapúa',
    '8': 'Misiones',
    '9': 'Paraguarí',
    '10': 'Alto Paraná',
    '11': 'Central',
    '12': 'Ñeembucú',
    '13': 'Amambay',
    '14': 'Canindeyú',
    '15': 'Presidente Hayes',
    '16': 'Alto Paraguay',
    '19': 'Boquerón',
    ASU: 'Asunción',
  },
  PE: {
    AMA: 'Amarumayu',
    ANC: 'Ancash',
    APU: 'Apurímac',
    ARE: 'Arequipa',
    AYA: 'Ayacucho',
    CAJ: 'Cajamarca',
    CAL: 'El Callao',
    CUS: 'Cusco',
    HUC: 'Huánuco',
    HUV: 'Huancavelica',
    ICA: 'Ica',
    JUN: 'Hunin',
    LAL: 'La Libertad',
    LAM: 'Lambayeque',
    LIM: 'Lima',
    LMA: 'Lima hatun llaqta',
    LOR: 'Loreto',
    MDD: 'Madre de Dios',
    MOQ: 'Moquegua',
    PAS: 'Pasco',
    PIU: 'Piura',
    PUN: 'Puno',
    SAM: 'San Martin',
    TAC: 'Tacna',
    TUM: 'Tumbes',
    UCA: 'Ucayali',
  },
  PH: {
    '10': 'Northern Mindanao',
    '11': 'Davao',
    '12': 'Rehiyon ng Soccsksargen',
    '13': 'Caraga',
    '14': 'Autonomous Region in Muslim Mindanao',
    '15': 'Cordillera Administrative Region',
    '40': 'Calabarzon',
    '41': 'Mimaropa',
    '00': 'National Capital Region',
    '01': 'Ilocos',
    '02': 'Cagayan Valley',
    '03': 'Central Luzon',
    '05': 'Bicol',
    '06': 'Rehiyon ng Kanlurang Bisaya',
    '07': 'Central Visayas',
    '08': 'Eastern Visayas',
    '09': 'Rehiyon ng Tangway ng Sambuwangga',
    ABR: 'Abra',
    AGN: 'Agusan del Norte',
    AGS: 'Agusan del Sur',
    AKL: 'Aklan',
    ALB: 'Albay',
    ANT: 'Antike',
    APA: 'Apayao',
    AUR: 'Aurora',
    BAN: 'Bataan',
    BAS: 'Basilan',
    BEN: 'Benget',
    BIL: 'Biliran',
    BOH: 'Bohol',
    BTG: 'Batangas',
    BTN: 'Batanes',
    BUK: 'Bukidnon',
    BUL: 'Bulacan',
    CAG: 'Cagayan',
    CAM: 'Camiguin',
    CAN: 'Camarines Norte',
    CAP: 'Capiz',
    CAS: 'Camarines Sur',
    CAT: 'Catanduanes',
    CAV: 'Cavite',
    CEB: 'Cebu',
    COM: 'Compostela Valley',
    DAO: 'Davao Oriental',
    DAS: 'Davao del Sur',
    DAV: 'Davao del Norte',
    DIN: 'Dinagat Islands',
    EAS: 'Eastern Samar',
    GUI: 'Gimaras',
    IFU: 'Ifugao',
    ILI: 'Iloilo',
    ILN: 'Hilagang Iloko',
    ILS: 'Ilocos Sur',
    ISA: 'Isabela',
    KAL: 'Kalinga',
    LAG: 'Laguna',
    LAN: 'Hilagang Lanaw',
    LAS: 'Lanao del Sur',
    LEY: 'Leyte',
    LUN: 'La Union',
    MAD: 'Marinduke',
    MAG: 'Magindanaw',
    MAS: 'Masbate',
    MDC: 'Kanlurang Mindoro',
    MDR: 'Mindoro Oriental',
    MOU: 'Lalawigang Bulubundukin',
    MSC: 'Kanlurang Misamis',
    MSR: 'Misamis Oriental',
    NCO: 'Cotabato',
    NEC: 'Kanlurang Negros',
    NER: 'Negros Oriental',
    NSA: 'Hilagang Samar',
    NUE: 'Nueva Ecija',
    NUV: 'Nueva Vizcaya',
    PAM: 'Pampanga',
    PAN: 'Pangasinan',
    PLW: 'Palawan',
    QUE: 'Keson',
    QUI: 'Kirino',
    RIZ: 'Risal',
    ROM: 'Romblon',
    SAR: 'Sarangani',
    SCO: 'South Cotabato',
    SIG: 'Sikihor',
    SLE: 'Katimogang Leyte',
    SLU: 'Sulu',
    SOR: 'Sorsogon',
    SUK: 'Sultan Kudarat',
    SUN: 'Hilagang Surigaw',
    SUR: 'Surigao del Sur',
    TAR: 'Tarlac',
    TAW: 'Tawi-Tawi',
    WSA: 'Samar',
    ZAN: 'Hilagang Sambuwangga',
    ZAS: 'Timog Sambuwangga',
    ZMB: 'Sambales',
    ZSI: 'Sambuwangga Sibugay',
  },
  PN: {
    PN: 'Pitcairn',
  },
  PL: {
    DS: 'Dolnośląskie',
    KP: 'Kujawsko-pomorskie',
    LB: 'Lubuskie',
    LD: 'Łódzkie',
    LU: 'Lubelskie',
    MA: 'Małopolskie',
    MZ: 'Mazowieckie',
    OP: 'Opolskie',
    PD: 'Podlaskie',
    PK: 'Podkarpackie',
    PM: 'Pomorskie',
    SK: 'Świętokrzyskie',
    SL: 'Śląskie',
    WN: 'Warmińsko-mazurskie',
    WP: 'Wielkopolskie',
    ZP: 'Zachodniopomorskie',
  },
  PT: {
    '10': 'Leiria',
    '11': 'Lisboa',
    '12': 'Portalegre',
    '13': 'Porto',
    '14': 'Santarém',
    '15': 'Setúbal',
    '16': 'Viana do Castelo',
    '17': 'Vila Real',
    '18': 'Viseu',
    '20': 'Região Autónoma dos Açores',
    '30': 'Região Autónoma da Madeira',
    '01': 'Aveiro',
    '02': 'Beja',
    '03': 'Braga',
    '04': 'Bragança',
    '05': 'Castelo Branco',
    '06': 'Coimbra',
    '07': 'Évora',
    '08': 'Faro',
    '09': 'Guarda',
  },
  PR: {
    PR: 'Puerto Rico',
  },
  QA: {
    DA: 'Ad Dawḩah',
    KH: 'Al Khawr wa adh Dhakhīrah',
    MS: 'Ash Shamāl',
    RA: 'Ar Rayyān',
    US: 'Umm Şalāl',
    WA: 'Al Wakrah',
    ZA: 'Az̧ Z̧a‘āyin',
  },
  RE: {
    RE: 'Reunion',
  },
  RO: {
    AB: 'Alba',
    AG: 'Argeş',
    AR: 'Arad',
    B: 'Bucureşti',
    BC: 'Bacău',
    BH: 'Bihor',
    BN: 'Bistriţa-Năsăud',
    BR: 'Brăila',
    BT: 'Botoşani',
    BV: 'Braşov',
    BZ: 'Buzău',
    CJ: 'Cluj',
    CL: 'Călăraşi',
    CS: 'Caraş-Severin',
    CT: 'Constanţa',
    CV: 'Covasna',
    DB: 'Dâmboviţa',
    DJ: 'Dolj',
    GJ: 'Gorj',
    GL: 'Galaţi',
    GR: 'Giurgiu',
    HD: 'Hunedoara',
    HR: 'Harghita',
    IF: 'Ilfov',
    IL: 'Ialomiţa',
    IS: 'Iaşi',
    MH: 'Mehedinţi',
    MM: 'Maramureş',
    MS: 'Mureş',
    NT: 'Neamţ',
    OT: 'Olt',
    PH: 'Prahova',
    SB: 'Sibiu',
    SJ: 'Sălaj',
    SM: 'Satu Mare',
    SV: 'Suceava',
    TL: 'Tulcea',
    TM: 'Timiş',
    TR: 'Teleorman',
    VL: 'Vâlcea',
    VN: 'Vrancea',
    VS: 'Vaslui',
  },
  RU: {
    AD: 'Adygeja, Respublika',
    AL: 'Altaj, Respublika',
    ALT: 'Altajskij kraj',
    AMU: "Amurskaja oblast'",
    ARK: "Arhangel'skaja oblast'",
    AST: "Astrahanskaja oblast'",
    BA: 'Bashkortostan, Respublika',
    BEL: "Belgorodskaja oblast'",
    BRY: "Brjanskaja oblast'",
    BU: 'Burjatija, Respublika',
    CE: 'Čečenskaja Respublika',
    CHE: "Čeljabinskaja oblast'",
    CHU: 'Chukotskiy avtonomnyy okrug',
    CU: 'Chuvashskaya Respublika',
    DA: 'Dagestan, Respublika',
    IN: 'Ingušetija, Respublika',
    IRK: "Irkutskaja oblast'",
    IVA: "Ivanovskaja oblast'",
    KAM: 'Kamčatskij kraj',
    KB: 'Kabardino-Balkarskaja Respublika',
    KC: 'Karačaevo-Čerkesskaja Respublika',
    KDA: 'Krasnodarskij kraj',
    KEM: "Kemerovskaja oblast'",
    KGD: "Kaliningradskaja oblast'",
    KGN: "Kurganskaja oblast'",
    KHA: 'Habarovskij kraj',
    KHM: 'Hanty-Mansijskij avtonomnyj okrug',
    KIR: "Kirovskaja oblast'",
    KK: 'Hakasija, Respublika',
    KL: 'Kalmykija, Respublika',
    KLU: "Kaluzhskaya oblast'",
    KO: 'Komi, Respublika',
    KOS: "Kostromskaja oblast'",
    KR: 'Karelija, Respublika',
    KRS: "Kurskaja oblast'",
    KYA: 'Krasnojarskij kraj',
    LEN: "Leningradskaja oblast'",
    LIP: "Lipeckaja oblast'",
    MAG: "Magadanskaja oblast'",
    ME: 'Marij Èl, Respublika',
    MO: 'Mordovija, Respublika',
    MOS: "Moskovskaja oblast'",
    MOW: 'Moskva',
    MUR: "Murmanskaja oblast'",
    NEN: 'Neneckij avtonomnyj okrug',
    NGR: "Novgorodskaja oblast'",
    NIZ: "Nižegorodskaja oblast'",
    NVS: "Novosibirskaja oblast'",
    OMS: "Omskaja oblast'",
    ORE: "Orenburgskaja oblast'",
    ORL: "Orlovskaja oblast'",
    PER: 'Permskij kraj',
    PNZ: "Penzenskaja oblast'",
    PRI: 'Primorskij kraj',
    PSK: "Pskovskaja oblast'",
    ROS: "Rostovskaja oblast'",
    RYA: "Rjazanskaja oblast'",
    SAK: "Sahalinskaja oblast'",
    SAM: "Samarskaja oblast'",
    SAR: "Saratovskaja oblast'",
    SA: 'Saha, Respublika',
    SE: 'Severnaja Osetija, Respublika',
    SMO: "Smolenskaja oblast'",
    SPE: 'Sankt-Peterburg',
    STA: "Stavropol'skij kraj",
    SVE: "Sverdlovskaja oblast'",
    TAM: "Tambovskaja oblast'",
    TA: 'Tatarstan, Respublika',
    TOM: "Tomskaja oblast'",
    TUL: "Tul'skaja oblast'",
    TVE: "Tverskaja oblast'",
    TY: 'Tyva, Respublika',
    TYU: "Tjumenskaja oblast'",
    UD: 'Udmurtskaja Respublika',
    ULY: "Ul'janovskaja oblast'",
    VGG: "Volgogradskaja oblast'",
    VLA: "Vladimirskaja oblast'",
    VLG: "Vologodskaja oblast'",
    VOR: "Voronezhskaya oblast'",
    YAN: 'Jamalo-Neneckij avtonomnyj okrug',
    YAR: "Jaroslavskaja oblast'",
    YEV: "Evrejskaja avtonomnaja oblast'",
    ZAB: "Zabajkal'skij kraj",
  },
  RW: {
    '01': 'Ville de Kigal',
    '02': 'Est',
    '03': 'Nord',
    '04': 'Ouest',
    '05': 'Sud',
  },
  SH: {
    AC: 'Ascension',
    HL: 'Saint Helena',
    TA: 'Tristan da Cunha',
  },
  KN: {
    '10': 'Saint Paul Charlestown',
    '11': 'Saint Peter Basseterre',
    '12': 'Saint Thomas Lowland',
    '13': 'Saint Thomas Middle Island',
    '15': 'Trinity Palmetto Point',
    '01': 'Christ Church Nichola Town',
    '02': 'Saint Anne Sandy Point',
    '03': 'Saint George Basseterre',
    '04': 'Saint George Gingerland',
    '05': 'Saint James Windward',
    '06': 'Saint John Capisterre',
    '07': 'Saint John Figtree',
    '08': 'Saint Mary Cayon',
    '09': 'Saint Paul Capisterre',
    K: 'Saint Kitts',
    N: 'Nevis',
  },
  LC: {
    '10': 'Soufrière',
    '11': 'Vieux Fort',
    '12': 'Canaries',
    '01': 'Anse la Raye',
    '02': 'Castries',
    '03': 'Choiseul',
    '05': 'Dennery',
    '06': 'Gros Islet',
    '07': 'Laborie',
    '08': 'Micoud',
  },
  VC: {
    '01': 'Charlotte',
    '02': 'Saint Andrew',
    '03': 'Saint David',
    '04': 'Saint George',
    '05': 'Saint Patrick',
    '06': 'Grenadines',
  },
  WS: {
    AA: "A'ana",
    AL: 'Aiga-i-le-Tai',
    AT: 'Atua',
    FA: "Fa'asaleleaga",
    GE: "Gaga'emauga",
    GI: 'Gagaifomauga',
    PA: 'Palauli',
    SA: "Satupa'itea",
    TU: 'Tuamasaga',
    VF: "Va'a-o-Fonoti",
    VS: 'Vaisigano',
  },
  SM: {
    '01': 'Acquaviva',
    '02': 'Chiesanuova',
    '03': 'Domagnano',
    '04': 'Faetano',
    '05': 'Fiorentino',
    '06': 'Borgo Maggiore',
    '07': 'San Marino',
    '08': 'Montegiardino',
    '09': 'Serravalle',
  },
  ST: {
    P: 'Príncipe',
    S: 'São Tomé',
  },
  SA: {
    '10': 'Najrān',
    '11': 'Al Bāḩah',
    '12': 'Al Jawf',
    '14': "'Asīr",
    '01': 'Ar Riyāḑ',
    '02': 'Makkah al Mukarramah',
    '03': 'Al Madīnah al Munawwarah',
    '04': 'Ash Sharqīyah',
    '05': 'Al Qaşīm',
    '06': "Ḩā'il",
    '07': 'Tabūk',
    '08': 'Al Ḩudūd ash Shamālīyah',
    '09': 'Jāzān',
  },
  SN: {
    DB: 'Diourbel',
    DK: 'Dakar',
    FK: 'Fatick',
    KA: 'Kaffrine',
    KD: 'Kolda',
    KE: 'Kédougou',
    KL: 'Kaolack',
    LG: 'Louga',
    MT: 'Matam',
    SE: 'Sédhiou',
    SL: 'Saint-Louis',
    TC: 'Tambacounda',
    TH: 'Thiès',
    ZG: 'Ziguinchor',
  },
  RS: {
    '10': 'Podunavski okrug',
    '11': 'Braničevski okrug',
    '12': 'Šumadijski okrug',
    '13': 'Pomoravski okrug',
    '14': 'Borski okrug',
    '15': 'Zaječarski okrug',
    '16': 'Zlatiborski okrug',
    '17': 'Moravički okrug',
    '18': 'Raški okrug',
    '19': 'Rasinski okrug',
    '20': 'Nišavski okrug',
    '21': 'Toplički okrug',
    '22': 'Pirotski okrug',
    '23': 'Jablanički okrug',
    '24': 'Pčinjski okrug',
    '25': 'Kosovski okrug',
    '26': 'Pećki okrug',
    '27': 'Prizrenski okrug',
    '28': 'Kosovsko-Mitrovački okrug',
    '29': 'Kosovsko-Pomoravski okrug',
    '00': 'Beograd',
    '01': 'Severnobački okrug',
    '02': 'Srednjebanatski okrug',
    '03': 'Severnobanatski okrug',
    '04': 'Južnobanatski okrug',
    '05': 'Zapadnobački okrug',
    '06': 'Južnobački okrug',
    '07': 'Sremski okrug',
    '08': 'Mačvanski okrug',
    '09': 'Kolubarski okrug',
    KM: 'Kosovo-Metohija',
    VO: 'Vojvodina',
  },
  SC: {
    '10': 'Bel Ombre',
    '11': 'Cascade',
    '12': 'Glacis',
    '13': "Grand'Anse Mahé",
    '14': "Grand'Anse Praslin",
    '15': 'Ladig',
    '16': 'English River',
    '17': 'Mon Bikston',
    '18': 'Mon Fleri',
    '19': 'Plaisance',
    '20': 'Pointe La Rue',
    '21': 'Porglo',
    '22': 'Saint Louis',
    '23': 'Takamaka',
    '24': 'Lemamel',
    '25': 'Roche Caïman',
    '01': 'Anse aux Pins',
    '02': 'Ans Bwalo',
    '03': 'Anse Etoile',
    '04': 'Au Cap',
    '05': 'Anse Royale',
    '06': 'Baie Lazare',
    '07': 'Baie Sainte-Anne',
    '08': 'Beau Vallon',
    '09': 'Bel Air',
  },
  GS: {
    GS: 'S.Georgia & S.Sandwich Islands',
  },
  SL: {
    E: 'Eastern',
    N: 'Northern',
    S: 'Southern',
    W: 'Western Area',
  },
  SG: {
    '01': 'Central Singapore',
    '02': 'North East',
    '03': 'North West',
    '04': 'South East',
    '05': 'South West',
  },
  SK: {
    BC: 'Banskobystrický kraj',
    BL: 'Bratislavský kraj',
    KI: 'Košický kraj',
    NI: 'Nitriansky kraj',
    PV: 'Prešovský kraj',
    TA: 'Trnavský kraj',
    TC: 'Trenčiansky kraj',
    ZI: 'Žilinský kraj',
  },
  SI: {
    '100': 'Radenci',
    '101': 'Radlje ob Dravi',
    '102': 'Radovljica',
    '103': 'Ravne na Koroškem',
    '104': 'Ribnica',
    '105': 'Rogašovci',
    '106': 'Rogaška Slatina',
    '107': 'Rogatec',
    '108': 'Ruše',
    '109': 'Semič',
    '110': 'Sevnica',
    '111': 'Sežana',
    '112': 'Slovenj Gradec',
    '113': 'Slovenska Bistrica',
    '114': 'Slovenske Konjice',
    '115': 'Starše',
    '116': 'Sveti Jurij',
    '117': 'Šenčur',
    '118': 'Šentilj',
    '119': 'Šentjernej',
    '120': 'Šentjur',
    '121': 'Škocjan',
    '122': 'Škofja Loka',
    '123': 'Škofljica',
    '124': 'Šmarje pri Jelšah',
    '125': 'Šmartno ob Paki',
    '126': 'Šoštanj',
    '127': 'Štore',
    '128': 'Tolmin',
    '129': 'Trbovlje',
    '130': 'Trebnje',
    '131': 'Tržič',
    '132': 'Turnišče',
    '133': 'Velenje',
    '134': 'Velike Lašče',
    '135': 'Videm',
    '136': 'Vipava',
    '137': 'Vitanje',
    '138': 'Vodice',
    '139': 'Vojnik',
    '140': 'Vrhnika',
    '141': 'Vuzenica',
    '142': 'Zagorje ob Savi',
    '143': 'Zavrč',
    '144': 'Zreče',
    '146': 'Železniki',
    '147': 'Žiri',
    '148': 'Benedikt',
    '149': 'Bistrica ob Sotli',
    '150': 'Bloke',
    '151': 'Braslovče',
    '152': 'Cankova',
    '153': 'Cerkvenjak',
    '154': 'Dobje',
    '155': 'Dobrna',
    '156': 'Dobrovnik',
    '157': 'Dolenjske Toplice',
    '158': 'Grad',
    '159': 'Hajdina',
    '160': 'Hoče-Slivnica',
    '161': 'Hodoš',
    '162': 'Horjul',
    '163': 'Jezersko',
    '164': 'Komenda',
    '165': 'Kostel',
    '166': 'Križevci',
    '167': 'Lovrenc na Pohorju',
    '168': 'Markovci',
    '169': 'Miklavž na Dravskem Polju',
    '170': 'Mirna Peč',
    '171': 'Oplotnica',
    '172': 'Podlehnik',
    '173': 'Polzela',
    '174': 'Prebold',
    '175': 'Prevalje',
    '176': 'Razkrižje',
    '177': 'Ribnica na Pohorju',
    '178': 'Selnica ob Dravi',
    '179': 'Sodražica',
    '180': 'Solčava',
    '181': 'Sveta Ana',
    '182': 'Sveti Andraž v Slovenskih Goricah',
    '183': 'Šempeter-Vrtojba',
    '184': 'Tabor',
    '185': 'Trnovska Vas',
    '186': 'Trzin',
    '187': 'Velika Polana',
    '188': 'Veržej',
    '189': 'Vransko',
    '190': 'Žalec',
    '191': 'Žetale',
    '192': 'Žirovnica',
    '193': 'Žužemberk',
    '194': 'Šmartno pri Litiji',
    '195': 'Apače',
    '196': 'Cirkulane',
    '197': 'Kosanjevica na Krki',
    '198': 'Makole',
    '199': 'Mokronog-Trebelno',
    '200': 'Poljčane',
    '201': 'Renče-Vogrsko',
    '202': 'Središče ob Dravi',
    '203': 'Straža',
    '204': 'Sveta Trojica v Slovenskih Goricah',
    '205': 'Sveti Tomaž',
    '206': 'Šmarješke Toplice',
    '207': 'Gorje',
    '208': 'Log-Dragomer',
    '209': 'Rečica ob Savinji',
    '210': 'Sveti Jurij v Slovenskih Goricah',
    '211': 'Šentrupert',
    '212': 'Mirna',
    '001': 'Ajdovščina',
    '002': 'Beltinci',
    '003': 'Bled',
    '004': 'Bohinj',
    '005': 'Borovnica',
    '006': 'Bovec',
    '007': 'Brda',
    '008': 'Brezovica',
    '009': 'Brežice',
    '010': 'Tišina',
    '011': 'Celje',
    '012': 'Cerklje na Gorenjskem',
    '013': 'Cerknica',
    '014': 'Cerkno',
    '015': 'Črenšovci',
    '016': 'Črna na Koroškem',
    '017': 'Črnomelj',
    '018': 'Destrnik',
    '019': 'Divača',
    '020': 'Dobrepolje',
    '021': 'Dobrova-Polhov Gradec',
    '022': 'Dol pri Ljubljani',
    '023': 'Domžale',
    '024': 'Dornava',
    '025': 'Dravograd',
    '026': 'Duplek',
    '027': 'Gorenja vas-Poljane',
    '028': 'Gorišnica',
    '029': 'Gornja Radgona',
    '030': 'Gornji Grad',
    '031': 'Gornji Petrovci',
    '032': 'Grosuplje',
    '033': 'Šalovci',
    '034': 'Hrastnik',
    '035': 'Hrpelje-Kozina',
    '036': 'Idrija',
    '037': 'Ig',
    '038': 'Ilirska Bistrica',
    '039': 'Ivančna Gorica',
    '040': 'Izola',
    '041': 'Jesenice',
    '042': 'Juršinci',
    '043': 'Kamnik',
    '044': 'Kanal',
    '045': 'Kidričevo',
    '046': 'Kobarid',
    '047': 'Kobilje',
    '048': 'Kočevje',
    '049': 'Komen',
    '050': 'Koper',
    '051': 'Kozje',
    '052': 'Kranj',
    '053': 'Kranjska Gora',
    '054': 'Krško',
    '055': 'Kungota',
    '056': 'Kuzma',
    '057': 'Laško',
    '058': 'Lenart',
    '059': 'Lendava',
    '060': 'Litija',
    '061': 'Ljubljana',
    '062': 'Ljubno',
    '063': 'Ljutomer',
    '064': 'Logatec',
    '065': 'Loška Dolina',
    '066': 'Loški Potok',
    '067': 'Luče',
    '068': 'Lukovica',
    '069': 'Majšperk',
    '070': 'Maribor',
    '071': 'Medvode',
    '072': 'Mengeš',
    '073': 'Metlika',
    '074': 'Mežica',
    '075': 'Miren-Kostanjevica',
    '076': 'Mislinja',
    '077': 'Moravče',
    '078': 'Moravske Toplice',
    '079': 'Mozirje',
    '080': 'Murska Sobota',
    '081': 'Muta',
    '082': 'Naklo',
    '083': 'Nazarje',
    '084': 'Nova Gorica',
    '085': 'Novo Mesto',
    '086': 'Odranci',
    '087': 'Ormož',
    '088': 'Osilnica',
    '089': 'Pesnica',
    '090': 'Piran',
    '091': 'Pivka',
    '092': 'Podčetrtek',
    '093': 'Podvelka',
    '094': 'Postojna',
    '095': 'Preddvor',
    '096': 'Ptuj',
    '097': 'Puconci',
    '098': 'Rače-Fram',
    '099': 'Radeče',
  },
  SB: {
    CE: 'Central',
    CH: 'Choiseul',
    CT: 'Capital Territory',
    GU: 'Guadalcanal',
    IS: 'Isabel',
    MK: 'Makira-Ulawa',
    ML: 'Malaita',
    RB: 'Rennell and Bellona',
    TE: 'Temotu',
    WE: 'Western',
  },
  SO: {
    AW: 'Awdal',
    BK: 'Bakool',
    BN: 'Banaadir',
    BR: 'Bari',
    BY: 'Bay',
    GA: 'Galguduud',
    GE: 'Gedo',
    HI: 'Hiiraan',
    JD: 'Jubbada Dhexe',
    JH: 'Jubbada Hoose',
    MU: 'Mudug',
    NU: 'Nugaal',
    SA: 'Sanaag',
    SD: 'Shabeellaha Dhexe',
    SH: 'Shabeellaha Hoose',
    SO: 'Sool',
    TO: 'Togdheer',
    WO: 'Woqooyi Galbeed',
  },
  ZA: {
    EC: 'Eastern Cape',
    FS: 'Foreisetata',
    GT: 'Gauteng',
    LP: 'Limpopo',
    MP: 'iMpumalanga',
    NC: 'iTlhagwini-Kapa',
    NL: 'GaZulu-Natala',
    NW: 'Bokone Bophirima',
    WC: 'iTjhingalanga-Kapa',
  },
  SS: {
    BN: 'Northern Bahr el Ghazal',
    BW: 'Western Bahr el Ghazal',
    EC: 'Central Equatoria',
    EE: 'Eastern Equatoria',
    EW: 'Western Equatoria',
    JG: 'Jonglei',
    LK: 'Lakes',
    NU: 'Upper Nile',
    UY: 'Unity',
    WR: 'Warrap',
  },
  ES: {
    A: 'Alacant*',
    AB: 'Albacete',
    AL: 'Almería',
    AN: 'Andalucía',
    AR: 'Aragón',
    AS: 'Asturias, Principado de',
    AV: 'Ávila',
    BA: 'Badajoz',
    B: 'Barcelona',
    BI: 'Bizkaia*',
    BU: 'Burgos',
    CA: 'Cádiz',
    C: 'A Coruña',
    CB: 'Cantabria',
    CC: 'Cáceres',
    CE: 'Ceuta',
    CL: 'Castilla y León',
    CM: 'Castilla-La Mancha',
    CN: 'Canarias',
    CO: 'Córdoba',
    CR: 'Ciudad Real',
    CS: 'Castelló*',
    CT: 'Catalunya',
    CU: 'Cuenca',
    EX: 'Extremadura',
    GA: 'Galicia',
    GC: 'Las Palmas',
    GI: 'Girona',
    GR: 'Granada',
    GU: 'Guadalajara',
    H: 'Huelva',
    HU: 'Huesca',
    IB: 'Illes Balears',
    J: 'Jaén',
    LE: 'León',
    L: 'Lleida',
    LO: 'La Rioja',
    LU: 'Lugo',
    MA: 'Málaga',
    MC: 'Murcia, Región de',
    MD: 'Madrid, Comunidad de',
    ML: 'Melilla',
    M: 'Madrid',
    MU: 'Murcia',
    NA: 'Nafarroa*',
    NC: 'Nafarroako Foru Komunitatea*',
    O: 'Asturias',
    OR: 'Ourense',
    PM: 'Balears',
    PO: 'Pontevedra',
    P: 'Palencia',
    PV: 'Euskal Herria',
    RI: 'La Rioja',
    SA: 'Salamanca',
    S: 'Cantabria',
    SE: 'Sevilla',
    SG: 'Segovia',
    SO: 'Soria',
    SS: 'Gipuzkoa*',
    TE: 'Teruel',
    TF: 'Santa Cruz de Tenerife',
    TO: 'Toledo',
    T: 'Tarragona',
    VA: 'Valladolid',
    VC: 'Valenciana, Comunidad',
    VI: 'Álava',
    V: 'Valencia',
    ZA: 'Zamora',
    Z: 'Zaragoza',
  },
  LK: {
    '1': 'Basnāhira paḷāta',
    '2': 'Central Province',
    '3': 'Dakuṇu paḷāta',
    '4': 'Northern Province',
    '5': 'Eastern Province',
    '6': 'North Western Province',
    '7': 'North Central Province',
    '8': 'Ūvā mākāṇam',
    '9': 'Chappirakamuva mākāṇam',
    '11': 'Colombo',
    '12': 'Gampaha',
    '13': 'Kalutara',
    '21': 'Kandy',
    '22': 'Matale',
    '23': 'Nuvara Ĕliya',
    '31': 'Gālla',
    '32': 'Matara',
    '33': 'Ampāntōṭṭai',
    '41': 'Jaffna',
    '42': 'Kilinochchi',
    '43': 'Mannar',
    '44': 'Vavuniya',
    '45': 'Mulativ',
    '51': 'Batticaloa',
    '52': 'Ampara',
    '53': 'Tirukŏṇamalai',
    '61': 'Kuruṇægala',
    '62': 'Puttalam',
    '71': 'Anuradhapura',
    '72': 'Pŏlaṉṉaṛuvai',
    '81': 'Badulla',
    '82': 'Monaragala',
    '91': 'Irattiṉapuri',
    '92': 'Kægalla',
  },
  BL: {
    BL: 'St. Barthélemy',
  },
  SX: {
    SX: 'St. Maarten',
  },
  MF: {
    MF: 'St. Martin',
  },
  PM: {
    PM: 'St. Pierre & Miquelon',
  },
  SD: {
    DC: 'Central Darfur',
    DE: 'East Darfur',
    DN: 'North Darfur',
    DS: 'Janūb Dārfūr',
    DW: 'Gharb Dārfūr',
    GD: 'Al Qaḑārif',
    GZ: 'Al Jazīrah',
    KA: 'Kassala',
    KH: 'Al Kharţūm',
    KN: 'North Kordofan',
    KS: 'Janūb Kurdufān',
    NB: 'An Nīl al Azraq',
    NO: 'Ash Shamālīyah',
    NR: 'An Nīl',
    NW: 'An Nīl al Abyaḑ',
    RS: 'Al Baḩr al Aḩmar',
    SI: 'Sennar',
  },
  SR: {
    BR: 'Brokopondo',
    CM: 'Commewijne',
    CR: 'Coronie',
    MA: 'Marowijne',
    NI: 'Nickerie',
    PM: 'Paramaribo',
    PR: 'Para',
    SA: 'Saramacca',
    SI: 'Sipaliwini',
    WA: 'Wanica',
  },
  SJ: {
    SJ: 'Svalbard & Jan Mayen Islands',
  },
  SZ: {
    HH: 'Hhohho',
    LU: 'Lubombo',
    MA: 'Manzini',
    SH: 'Shiselweni',
  },
  SE: {
    AB: 'Stockholms län',
    AC: 'Västerbottens län',
    BD: 'Norrbottens län',
    C: 'Uppsala län',
    D: 'Södermanlands län',
    E: 'Östergötlands län',
    F: 'Jönköpings län',
    G: 'Kronobergs län',
    H: 'Kalmar län',
    I: 'Gotlands län',
    K: 'Blekinge län',
    M: 'Skåne län',
    N: 'Hallands län',
    O: 'Västra Götalands län',
    S: 'Värmlands län',
    T: 'Örebro län',
    U: 'Västmanlands län',
    W: 'Dalarnas län',
    X: 'Gävleborgs län',
    Y: 'Västernorrlands län',
    Z: 'Jämtlands län',
  },
  CH: {
    AG: 'Aargau',
    AI: 'Appenzell Innerrhoden',
    AR: 'Appenzell Ausserrhoden',
    BE: 'Bern',
    BL: 'Basel-Landschaft',
    BS: 'Basel-Stadt',
    FR: 'Freiburg',
    GE: 'Genève',
    GL: 'Glarus',
    GR: 'Graubünden',
    JU: 'Jura',
    LU: 'Luzern',
    NE: 'Neuchâtel',
    NW: 'Nidwalden',
    OW: 'Obwalden',
    SG: 'Sankt Gallen',
    SH: 'Schaffhausen',
    SO: 'Solothurn',
    SZ: 'Schwyz',
    TG: 'Thurgau',
    TI: 'Ticino',
    UR: 'Uri',
    VD: 'Vaud',
    VS: 'Valais',
    ZG: 'Zug',
    ZH: 'Zürich',
  },
  SY: {
    DI: 'Dimashq',
    DR: "Dar'ā",
    DY: 'Dayr az Zawr',
    HA: 'Al Ḩasakah',
    HI: 'Ḩimş',
    HL: 'Ḩalab',
    HM: 'Ḩamāh',
    ID: 'Idlib',
    LA: 'Al Lādhiqīyah',
    QU: 'Al Qunayţirah',
    RA: 'Ar Raqqah',
    RD: 'Rīf Dimashq',
    SU: "As Suwaydā'",
    TA: 'Ţarţūs',
  },
  TW: {
    CHA: 'Changhua',
    CYI: 'Chiayi',
    CYQ: 'Chiayi',
    HSQ: 'Hsinchu',
    HSZ: 'Hsinchu',
    HUA: 'Hualien',
    ILA: 'Ilan',
    KEE: 'Keelung',
    KHH: 'Kaohsiung',
    KHQ: 'Kaohsiung',
    MIA: 'Miaoli',
    NAN: 'Nantou',
    PEN: 'Penghu',
    PIF: 'Pingtung',
    TAO: 'Taoyuan',
    TNN: 'Tainan',
    TNQ: 'Tainan',
    TPE: 'Taipei',
    TPQ: 'Taipei',
    TTT: 'Taitung',
    TXG: 'Taichung',
    TXQ: 'Taichung',
    YUN: 'Yunlin',
  },
  TJ: {
    DU: 'Dushanbe',
    GB: 'Kŭhistoni Badakhshon',
    KT: 'Khatlon',
    SU: 'Sughd',
  },
  TZ: {
    '10': 'Kusini Pemba',
    '11': 'Kusini Unguja',
    '12': 'Lindi',
    '13': 'Mara',
    '14': 'Mbeya',
    '15': 'Mjini Magharibi',
    '16': 'Morogoro',
    '17': 'Mtwara',
    '18': 'Mwanza',
    '19': 'Coast',
    '20': 'Rukwa',
    '21': 'Ruvuma',
    '22': 'Shinyanga',
    '23': 'Singida',
    '24': 'Tabora',
    '25': 'Tanga',
    '26': 'Manyara',
    '27': 'Geita',
    '28': 'Katavi',
    '29': 'Njombe',
    '30': 'Simiyu',
    '01': 'Arusha',
    '02': 'Dar es Salaam',
    '03': 'Dodoma',
    '04': 'Iringa',
    '05': 'Kagera',
    '06': 'Kaskazini Pemba',
    '07': 'Kaskazini Unguja',
    '08': 'Kigoma',
    '09': 'Kilimanjaro',
  },
  TH: {
    '10': 'Krung Thep Maha Nakhon',
    '11': 'Samut Prakan',
    '12': 'Nonthaburi',
    '13': 'Pathum Thani',
    '14': 'Phra Nakhon Si Ayutthaya',
    '15': 'Ang Thong',
    '16': 'Lop Buri',
    '17': 'Sing Buri',
    '18': 'Chai Nat',
    '19': 'Saraburi',
    '20': 'Chon Buri',
    '21': 'Rayong',
    '22': 'Chanthaburi',
    '23': 'Trat',
    '24': 'Chachoengsao',
    '25': 'Prachin Buri',
    '26': 'Nakhon Nayok',
    '27': 'Sa Kaeo',
    '30': 'Nakhon Ratchasima',
    '31': 'Buri Ram',
    '32': 'Surin',
    '33': 'Si Sa Ket',
    '34': 'Ubon Ratchathani',
    '35': 'Yasothon',
    '36': 'Chaiyaphum',
    '37': 'Amnat Charoen',
    '38': 'Bueng Kan',
    '39': 'Nong Bua Lam Phu',
    '40': 'Khon Kaen',
    '41': 'Udon Thani',
    '42': 'Loei',
    '43': 'Nong Khai',
    '44': 'Maha Sarakham',
    '45': 'Roi Et',
    '46': 'Kalasin',
    '47': 'Sakon Nakhon',
    '48': 'Nakhon Phanom',
    '49': 'Mukdahan',
    '50': 'Chiang Mai',
    '51': 'Lamphun',
    '52': 'Lampang',
    '53': 'Uttaradit',
    '54': 'Phrae',
    '55': 'Nan',
    '56': 'Phayao',
    '57': 'Chiang Rai',
    '58': 'Mae Hong Son',
    '60': 'Nakhon Sawan',
    '61': 'Uthai Thani',
    '62': 'Kamphaeng Phet',
    '63': 'Tak',
    '64': 'Sukhothai',
    '65': 'Phitsanulok',
    '66': 'Phichit',
    '67': 'Phetchabun',
    '70': 'Ratchaburi',
    '71': 'Kanchanaburi',
    '72': 'Suphan Buri',
    '73': 'Nakhon Pathom',
    '74': 'Samut Sakhon',
    '75': 'Samut Songkhram',
    '76': 'Phetchaburi',
    '77': 'Prachuap Khiri Khan',
    '80': 'Nakhon Si Thammarat',
    '81': 'Krabi',
    '82': 'Phangnga',
    '83': 'Phuket',
    '84': 'Surat Thani',
    '85': 'Ranong',
    '86': 'Chumphon',
    '90': 'Songkhla',
    '91': 'Satun',
    '92': 'Trang',
    '93': 'Phatthalung',
    '94': 'Pattani',
    '95': 'Yala',
    '96': 'Narathiwat',
    S: 'Phatthaya',
  },
  TL: {
    AL: 'Aileu',
    AN: 'Ainaro',
    BA: 'Baucau',
    BO: 'Bobonaro',
    CO: 'Cova Lima',
    DI: 'Díli',
    ER: 'Ermera',
    LA: 'Lautém',
    LI: 'Likisá',
    MF: 'Manufahi',
    MT: 'Manatuto',
    OE: 'Oecussi',
    VI: 'Vikeke',
  },
  TG: {
    C: 'Centre',
    K: 'Kara',
    M: 'Maritime',
    P: 'Plateaux',
    S: 'Savannes',
  },
  TK: {
    TK: 'Tokelau',
  },
  TO: {
    '01': "'Eua",
    '02': "Ha'apai",
    '03': 'Niuas',
    '04': 'Tongatapu',
    '05': "Vava'u",
  },
  TT: {
    ARI: 'Arima',
    CHA: 'Chaguanas',
    CTT: 'Couva-Tabaquite-Talparo',
    DMN: 'Diego Martin',
    ETO: 'Eastern Tobago',
    PED: 'Penal-Debe',
    POS: 'Port of Spain',
    PRT: 'Princes Town',
    PTF: 'Point Fortin',
    RCM: 'Rio Claro-Mayaro',
    SFO: 'San Fernando',
    SGE: 'Sangre Grande',
    SIP: 'Siparia',
    SJL: 'San Juan-Laventille',
    TUP: 'Tunapuna-Piarco',
    WTO: 'Western Tobago',
  },
  TN: {
    '11': 'Tunis',
    '12': 'Ariana',
    '13': 'Ben Arous',
    '14': 'La Manouba',
    '21': 'Nabeul',
    '22': 'Zaghouan',
    '23': 'Bizerte',
    '31': 'Béja',
    '32': 'Jendouba',
    '33': 'Le Kef',
    '34': 'Siliana',
    '41': 'Kairouan',
    '42': 'Kasserine',
    '43': 'Sidi Bouzid',
    '51': 'Sousse',
    '52': 'Monastir',
    '53': 'Mahdia',
    '61': 'Sfax',
    '71': 'Gafsa',
    '72': 'Tozeur',
    '73': 'Kebili',
    '81': 'Gabès',
    '82': 'Medenine',
    '83': 'Tataouine',
  },
  TR: {
    '10': 'Balıkesir',
    '11': 'Bilecik',
    '12': 'Bingöl',
    '13': 'Bitlis',
    '14': 'Bolu',
    '15': 'Burdur',
    '16': 'Bursa',
    '17': 'Çanakkale',
    '18': 'Çankırı',
    '19': 'Çorum',
    '20': 'Denizli',
    '21': 'Diyarbakır',
    '22': 'Edirne',
    '23': 'Elazığ',
    '24': 'Erzincan',
    '25': 'Erzurum',
    '26': 'Eskişehir',
    '27': 'Gaziantep',
    '28': 'Giresun',
    '29': 'Gümüşhane',
    '30': 'Hakkâri',
    '31': 'Hatay',
    '32': 'Isparta',
    '33': 'Mersin',
    '34': 'İstanbul',
    '35': 'İzmir',
    '36': 'Kars',
    '37': 'Kastamonu',
    '38': 'Kayseri',
    '39': 'Kırklareli',
    '40': 'Kırşehir',
    '41': 'Kocaeli',
    '42': 'Konya',
    '43': 'Kütahya',
    '44': 'Malatya',
    '45': 'Manisa',
    '46': 'Kahramanmaraş',
    '47': 'Mardin',
    '48': 'Muğla',
    '49': 'Muş',
    '50': 'Nevşehir',
    '51': 'Niğde',
    '52': 'Ordu',
    '53': 'Rize',
    '54': 'Sakarya',
    '55': 'Samsun',
    '56': 'Siirt',
    '57': 'Sinop',
    '58': 'Sivas',
    '59': 'Tekirdağ',
    '60': 'Tokat',
    '61': 'Trabzon',
    '62': 'Tunceli',
    '63': 'Şanlıurfa',
    '64': 'Uşak',
    '65': 'Van',
    '66': 'Yozgat',
    '67': 'Zonguldak',
    '68': 'Aksaray',
    '69': 'Bayburt',
    '70': 'Karaman',
    '71': 'Kırıkkale',
    '72': 'Batman',
    '73': 'Şırnak',
    '74': 'Bartın',
    '75': 'Ardahan',
    '76': 'Iğdır',
    '77': 'Yalova',
    '78': 'Karabük',
    '79': 'Kilis',
    '80': 'Osmaniye',
    '81': 'Düzce',
    '01': 'Adana',
    '02': 'Adıyaman',
    '03': 'Afyonkarahisar',
    '04': 'Ağrı',
    '05': 'Amasya',
    '06': 'Ankara',
    '07': 'Antalya',
    '08': 'Artvin',
    '09': 'Aydın',
  },
  TM: {
    A: 'Ahal',
    B: 'Balkan',
    D: 'Daşoguz',
    L: 'Lebap',
    M: 'Mary',
    S: 'Aşgabat',
  },
  TC: {
    TC: 'Turks & Caicos Islands',
  },
  TV: {
    FUN: 'Funafuti',
    NIT: 'Niutao',
    NKF: 'Nukufetau',
    NKL: 'Nukulaelae',
    NMA: 'Nanumea',
    NMG: 'Nanumanga',
    NUI: 'Nui',
    VAI: 'Vaitupu',
  },
  UG: {
    '101': 'Kalangala',
    '102': 'Kampala',
    '103': 'Kiboga',
    '104': 'Luwero',
    '105': 'Masaka',
    '106': 'Mpigi',
    '107': 'Mubende',
    '108': 'Mukono',
    '109': 'Nakasongola',
    '110': 'Rakai',
    '111': 'Sembabule',
    '112': 'Kayunga',
    '113': 'Wakiso',
    '114': 'Mityana',
    '115': 'Nakaseke',
    '116': 'Lyantonde',
    '117': 'Buikwe',
    '118': 'Bukomansibi',
    '119': 'Butambala',
    '120': 'Buvuma',
    '121': 'Gomba',
    '122': 'Kalungu',
    '123': 'Kyankwanzi',
    '124': 'Lwengo',
    '201': 'Bugiri',
    '202': 'Busia',
    '203': 'Iganga',
    '204': 'Jinja',
    '205': 'Kamuli',
    '206': 'Kapchorwa',
    '207': 'Katakwi',
    '208': 'Kumi',
    '209': 'Mbale',
    '210': 'Pallisa',
    '211': 'Soroti',
    '212': 'Tororo',
    '213': 'Kaberamaido',
    '214': 'Mayuge',
    '215': 'Sironko',
    '216': 'Amuria',
    '217': 'Budaka',
    '218': 'Bukwa',
    '219': 'Butaleja',
    '220': 'Kaliro',
    '221': 'Manafwa',
    '222': 'Namutumba',
    '223': 'Bududa',
    '224': 'Bukedea',
    '225': 'Bulambuli',
    '226': 'Buyende',
    '227': 'Kibuku',
    '228': 'Kween',
    '229': 'Luuka',
    '230': 'Namayingo',
    '231': 'Ngora',
    '232': 'Serere',
    '301': 'Adjumani',
    '302': 'Apac',
    '303': 'Arua',
    '304': 'Gulu',
    '305': 'Kitgum',
    '306': 'Kotido',
    '307': 'Lira',
    '308': 'Moroto',
    '309': 'Moyo',
    '310': 'Nebbi',
    '311': 'Nakapiripirit',
    '312': 'Pader',
    '313': 'Yumbe',
    '314': 'Amolatar',
    '315': 'Kaabong',
    '316': 'Koboko',
    '317': 'Abim',
    '318': 'Dokolo',
    '319': 'Amuru',
    '320': 'Maracha',
    '321': 'Oyam',
    '322': 'Agago',
    '323': 'Alebtong',
    '324': 'Amudat',
    '325': 'Buhweju',
    '326': 'Kole',
    '327': 'Lamwo',
    '328': 'Napak',
    '329': 'Nwoya',
    '330': 'Otuke',
    '331': 'Zombo',
    '401': 'Bundibugyo',
    '402': 'Bushenyi',
    '403': 'Hoima',
    '404': 'Kabale',
    '405': 'Kabarole',
    '406': 'Kasese',
    '407': 'Kibaale',
    '408': 'Kisoro',
    '409': 'Masindi',
    '410': 'Mbarara',
    '411': 'Ntungamo',
    '412': 'Rukungiri',
    '413': 'Kamwenge',
    '414': 'Kanungu',
    '415': 'Kyenjojo',
    '416': 'Ibanda',
    '417': 'Isingiro',
    '418': 'Kiruhura',
    '419': 'Buliisa',
    '420': 'Kiryandongo',
    '421': 'Kyegegwa',
    '422': 'Mitooma',
    '423': 'Ntoroko',
    '424': 'Rubirizi',
    '425': 'Sheema',
    C: 'Central',
    E: 'Eastern',
    N: 'Northern',
    W: 'Western',
  },
  UA: {
    '12': 'Dnipropetrovska oblast',
    '14': 'Donetska oblast',
    '18': 'Zhytomyrska oblast',
    '21': 'Zakarpatska oblast',
    '23': 'Zaporizka oblast',
    '26': 'Ivano-Frankivska oblast',
    '30': 'Kyiv',
    '32': 'Kyivska oblast',
    '35': 'Kirovohradska oblast',
    '40': 'Sevastopol',
    '43': 'Avtonomna Respublika Krym',
    '46': 'Lvivska oblast',
    '48': 'Mykolaivska oblast',
    '51': 'Odeska oblast',
    '53': 'Poltavska oblast',
    '56': 'Rivnenska oblast',
    '59': 'Sumska oblast',
    '61': 'Ternopilska oblast',
    '63': 'Kharkivska oblast',
    '65': 'Khersonska oblast',
    '68': 'Khmelnytska oblast',
    '71': 'Cherkaska oblast',
    '74': 'Chernihivska oblast',
    '77': 'Chernivetska oblast',
    '05': 'Vinnytska oblast',
    '07': 'Volynska oblast',
    '09': 'Luhanska oblast',
  },
  AE: {
    AJ: "'Ajmān",
    AZ: 'Abū Z̧aby',
    DU: 'Dubayy',
    FU: 'Al Fujayrah',
    RK: "Ra's al Khaymah",
    SH: 'Ash Shāriqah',
    UQ: 'Umm al Qaywayn',
  },
  GB: {
    ABD: 'Aberdeenshire',
    ABE: 'Aberdeen City',
    AGB: 'Argyll and Bute',
    AGY: 'Isle of Anglesey',
    ANS: 'Angus',
    ANT: 'Antrim',
    ARD: 'Ards',
    ARM: 'Armagh',
    BAS: 'Bath and North East Somerset',
    BBD: 'Blackburn with Darwen',
    BDF: 'Bedford',
    BDG: 'Barking and Dagenham',
    BEN: 'Brent',
    BEX: 'Bexley',
    BFS: 'Belfast',
    BGE: 'Bridgend',
    BGW: 'Blaenau Gwent',
    BIR: 'Birmingham',
    BKM: 'Buckinghamshire',
    BLA: 'Ballymena',
    BLY: 'Ballymoney',
    BMH: 'Bournemouth',
    BNB: 'Banbridge',
    BNE: 'Barnet',
    BNH: 'Brighton and Hove',
    BNS: 'Barnsley',
    BOL: 'Bolton',
    BPL: 'Blackpool',
    BRC: 'Bracknell Forest',
    BRD: 'Bradford',
    BRY: 'Bromley',
    BST: 'Bristol, City of',
    BUR: 'Bury',
    CAM: 'Cambridgeshire',
    CAY: 'Caerphilly',
    CBF: 'Central Bedfordshire',
    CGN: 'Ceredigion',
    CGV: 'Craigavon',
    CHE: 'Cheshire East',
    CHW: 'Cheshire West and Chester',
    CKF: 'Carrickfergus',
    CKT: 'Cookstown',
    CLD: 'Calderdale',
    CLK: 'Clackmannanshire',
    CLR: 'Coleraine',
    CMA: 'Cumbria',
    CMD: 'Camden',
    CMN: 'Carmarthenshire',
    CON: 'Cornwall',
    COV: 'Coventry',
    CRF: 'Cardiff',
    CRY: 'Croydon',
    CSR: 'Castlereagh',
    CWY: 'Conwy',
    DAL: 'Darlington',
    DBY: 'Derbyshire',
    DEN: 'Denbighshire',
    DER: 'Derby',
    DEV: 'Devon',
    DGN: 'Dungannon and South Tyrone',
    DGY: 'Dumfries and Galloway',
    DNC: 'Doncaster',
    DND: 'Dundee City',
    DOR: 'Dorset',
    DOW: 'Down',
    DRY: 'Derry',
    DUD: 'Dudley',
    DUR: 'Durham County',
    EAL: 'Ealing',
    EAW: 'England and Wales',
    EAY: 'East Ayrshire',
    EDH: 'Edinburgh, City of',
    EDU: 'East Dunbartonshire',
    ELN: 'East Lothian',
    ELS: 'Eilean Siar',
    ENF: 'Enfield',
    ENG: 'England',
    ERW: 'East Renfrewshire',
    ERY: 'East Riding of Yorkshire',
    ESS: 'Essex',
    ESX: 'East Sussex',
    FAL: 'Falkirk',
    FER: 'Fermanagh',
    FIF: 'Fife',
    FLN: 'Flintshire',
    GAT: 'Gateshead',
    GBN: 'Great Britain',
    GLG: 'Glasgow City',
    GLS: 'Gloucestershire',
    GRE: 'Greenwich',
    GWN: 'Gwynedd',
    HAL: 'Halton',
    HAM: 'Hampshire',
    HAV: 'Havering',
    HCK: 'Hackney',
    HEF: 'Herefordshire',
    HIL: 'Hillingdon',
    HLD: 'Highland',
    HMF: 'Hammersmith and Fulham',
    HNS: 'Hounslow',
    HPL: 'Hartlepool',
    HRT: 'Hertfordshire',
    HRW: 'Harrow',
    HRY: 'Haringey',
    IOS: 'Isles of Scilly',
    IOW: 'Isle of Wight',
    ISL: 'Islington',
    IVC: 'Inverclyde',
    KEC: 'Kensington and Chelsea',
    KEN: 'Kent',
    KHL: 'Kingston upon Hull',
    KIR: 'Kirklees',
    KTT: 'Kingston upon Thames',
    KWL: 'Knowsley',
    LAN: 'Lancashire',
    LBH: 'Lambeth',
    LCE: 'Leicester',
    LDS: 'Leeds',
    LEC: 'Leicestershire',
    LEW: 'Lewisham',
    LIN: 'Lincolnshire',
    LIV: 'Liverpool',
    LMV: 'Limavady',
    LND: 'London, City of',
    LRN: 'Larne',
    LSB: 'Lisburn',
    LUT: 'Luton',
    MAN: 'Manchester',
    MDB: 'Middlesbrough',
    MDW: 'Medway',
    MFT: 'Magherafelt',
    MIK: 'Milton Keynes',
    MLN: 'Midlothian',
    MON: 'Monmouthshire',
    MRT: 'Merton',
    MRY: 'Moray',
    MTY: 'Merthyr Tydfil',
    MYL: 'Moyle',
    NAY: 'North Ayrshire',
    NBL: 'Northumberland',
    NDN: 'North Down',
    NEL: 'North East Lincolnshire',
    NET: 'Newcastle upon Tyne',
    NFK: 'Norfolk',
    NGM: 'Nottingham',
    NIR: 'Northern Ireland',
    NLK: 'North Lanarkshire',
    NLN: 'North Lincolnshire',
    NSM: 'North Somerset',
    NTA: 'Newtownabbey',
    NTH: 'Northamptonshire',
    NTL: 'Neath Port Talbot',
    NTT: 'Nottinghamshire',
    NTY: 'North Tyneside',
    NWM: 'Newham',
    NWP: 'Newport',
    NYK: 'North Yorkshire',
    NYM: 'Newry and Mourne',
    OLD: 'Oldham',
    OMH: 'Omagh',
    ORK: 'Orkney Islands',
    OXF: 'Oxfordshire',
    PEM: 'Pembrokeshire',
    PKN: 'Perth and Kinross',
    PLY: 'Plymouth',
    POL: 'Poole',
    POR: 'Portsmouth',
    POW: 'Powys',
    PTE: 'Peterborough',
    RCC: 'Redcar and Cleveland',
    RCH: 'Rochdale',
    RCT: 'Rhondda, Cynon, Taff',
    RDB: 'Redbridge',
    RDG: 'Reading',
    RFW: 'Renfrewshire',
    RIC: 'Richmond upon Thames',
    ROT: 'Rotherham',
    RUT: 'Rutland',
    SAW: 'Sandwell',
    SAY: 'South Ayrshire',
    SCB: 'Scottish Borders, The',
    SCT: 'Scotland',
    SFK: 'Suffolk',
    SFT: 'Sefton',
    SGC: 'South Gloucestershire',
    SHF: 'Sheffield',
    SHN: 'St. Helens',
    SHR: 'Shropshire',
    SKP: 'Stockport',
    SLF: 'Salford',
    SLG: 'Slough',
    SLK: 'South Lanarkshire',
    SND: 'Sunderland',
    SOL: 'Solihull',
    SOM: 'Somerset',
    SOS: 'Southend-on-Sea',
    SRY: 'Surrey',
    STB: 'Strabane',
    STE: 'Stoke-on-Trent',
    STG: 'Stirling',
    STH: 'Southampton',
    STN: 'Sutton',
    STS: 'Staffordshire',
    STT: 'Stockton-on-Tees',
    STY: 'South Tyneside',
    SWA: 'Swansea',
    SWD: 'Swindon',
    SWK: 'Southwark',
    TAM: 'Tameside',
    TFW: 'Telford and Wrekin',
    THR: 'Thurrock',
    TOB: 'Torbay',
    TOF: 'Torfaen',
    TRF: 'Trafford',
    TWH: 'Tower Hamlets',
    UKM: 'United Kingdom',
    VGL: 'Vale of Glamorgan, The',
    WAR: 'Warwickshire',
    WBK: 'West Berkshire',
    WDU: 'West Dunbartonshire',
    WFT: 'Waltham Forest',
    WGN: 'Wigan',
    WIL: 'Wiltshire',
    WKF: 'Wakefield',
    WLL: 'Walsall',
    WLN: 'West Lothian',
    WLS: 'Wales',
    WLV: 'Wolverhampton',
    WND: 'Wandsworth',
    WNM: 'Windsor and Maidenhead',
    WOK: 'Wokingham',
    WOR: 'Worcestershire',
    WRL: 'Wirral',
    WRT: 'Warrington',
    WRX: 'Wrexham',
    WSM: 'Westminster',
    WSX: 'West Sussex',
    YOR: 'York',
    ZET: 'Shetland Islands',
  },
  UM: {
    '67': 'Johnston Atoll',
    '71': 'Midway Islands',
    '76': 'Navassa Island',
    '79': 'Wake Island',
    '81': 'Baker Island',
    '84': 'Howland Island',
    '86': 'Jarvis Island',
    '89': 'Kingman Reef',
    '95': 'Palmyra Atoll',
  },
  US: {
    AK: 'Alaska',
    AL: 'Alabama',
    AR: 'Arkansas',
    AS: 'American Samoa',
    AZ: 'Arizona',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MP: 'Northern Mariana Islands',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UM: 'United States Minor Outlying Islands',
    UT: 'Utah',
    VA: 'Virginia',
    VI: 'Virgin Islands, U.S.',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming',
  },
  UY: {
    AR: 'Artigas',
    CA: 'Canelones',
    CL: 'Cerro Largo',
    CO: 'Colonia',
    DU: 'Durazno',
    FD: 'Florida',
    FS: 'Flores',
    LA: 'Lavalleja',
    MA: 'Maldonado',
    MO: 'Montevideo',
    PA: 'Paysandú',
    RN: 'Río Negro',
    RO: 'Rocha',
    RV: 'Rivera',
    SA: 'Salto',
    SJ: 'San José',
    SO: 'Soriano',
    TA: 'Tacuarembó',
    TT: 'Treinta y Tres',
  },
  UZ: {
    AN: 'Andijon',
    BU: 'Buxoro',
    FA: 'Farg‘ona',
    JI: 'Jizzax',
    NG: 'Namangan',
    NW: 'Navoiy',
    QA: 'Qashqadaryo',
    QR: 'Qoraqalpog‘iston Respublikasi',
    SA: 'Samarqand',
    SI: 'Sirdaryo',
    SU: 'Surxondaryo',
    TK: 'Toshkent',
    TO: 'Toshkent',
    XO: 'Xorazm',
  },
  VU: {
    MAP: 'Malampa',
    PAM: 'Pénama',
    SAM: 'Sanma',
    SEE: 'Shéfa',
    TAE: 'Taféa',
    TOB: 'Torba',
  },
  VA: {
    VA: 'Vatican City',
  },
  VE: {
    A: 'Distrito Capital',
    B: 'Anzoátegui',
    C: 'Apure',
    D: 'Aragua',
    E: 'Barinas',
    F: 'Bolívar',
    G: 'Carabobo',
    H: 'Cojedes',
    I: 'Falcón',
    J: 'Guárico',
    K: 'Lara',
    L: 'Mérida',
    M: 'Miranda',
    N: 'Monagas',
    O: 'Nueva Esparta',
    P: 'Portuguesa',
    R: 'Sucre',
    S: 'Táchira',
    T: 'Trujillo',
    U: 'Yaracuy',
    V: 'Zulia',
    W: 'Dependencias Federales',
    X: 'Vargas',
    Y: 'Delta Amacuro',
    Z: 'Amazonas',
  },
  VN: {
    '13': 'Quảng Ninh',
    '14': 'Hòa Bình',
    '18': 'Ninh Bình',
    '20': 'Thái Bình',
    '21': 'Thanh Hóa',
    '22': 'Nghệ An',
    '23': 'Hà Tĩnh',
    '24': 'Quảng Bình',
    '25': 'Quảng Trị',
    '26': 'Thừa Thiên-Huế',
    '27': 'Quảng Nam',
    '28': 'Kon Tum',
    '29': 'Quảng Ngãi',
    '30': 'Gia Lai',
    '31': 'Bình Định',
    '32': 'Phú Yên',
    '33': 'Đắk Lắk',
    '34': 'Khánh Hòa',
    '35': 'Lâm Ðồng',
    '36': 'Ninh Thuận',
    '37': 'Tây Ninh',
    '39': 'Ðồng Nai',
    '40': 'Bình Thuận',
    '41': 'Long An',
    '43': 'Bà Rịa - Vũng Tàu',
    '44': 'An Giang',
    '45': 'Ðồng Tháp',
    '46': 'Tiền Giang',
    '47': 'Kiến Giang',
    '49': 'Vĩnh Long',
    '50': 'Bến Tre',
    '51': 'Trà Vinh',
    '52': 'Sóc Trăng',
    '53': 'Bắc Kạn',
    '54': 'Bắc Giang',
    '55': 'Bạc Liêu',
    '56': 'Bắc Ninh',
    '57': 'Bình Dương',
    '58': 'Bình Phước',
    '59': 'Cà Mau',
    '61': 'Hải Dương',
    '63': 'Hà Nam',
    '66': 'Hưng Yên',
    '67': 'Nam Ðịnh',
    '68': 'Phú Thọ',
    '69': 'Thái Nguyên',
    '70': 'Vĩnh Phúc',
    '71': 'Điện Biên',
    '72': 'Đắk Nông',
    '73': 'Hậu Giang',
    '01': 'Lai Châu',
    '02': 'Lào Cai',
    '03': 'Hà Giang',
    '04': 'Cao Bằng',
    '05': 'Sơn La',
    '06': 'Yên Bái',
    '07': 'Tuyên Quang',
    '09': 'Lạng Sơn',
    CT: 'Can Tho',
    DN: 'Da Nang',
    HN: 'Ha Noi',
    HP: 'Hai Phong',
    SG: 'Ho Chi Minh',
  },
  VG: {
    VG: 'Virgin Islands',
  },
  VI: {
    VI: 'Virgin Islands',
  },
  WF: {
    WF: 'Wallis & Futuna Islands',
  },
  EH: {
    EH: 'Western Sahara',
  },
  YE: {
    AB: 'Abyān',
    AD: "'Adan",
    AM: "'Amrān",
    BA: "Al Bayḑā'",
    DA: "Aḑ Ḑāli'",
    DH: 'Dhamār',
    HD: 'Ḩaḑramawt',
    HJ: 'Ḩajjah',
    HU: 'Al Ḩudaydah',
    IB: 'Ibb',
    JA: 'Al Jawf',
    LA: 'Laḩij',
    MA: "Ma'rib",
    MR: 'Al Mahrah',
    MW: 'Al Maḩwīt',
    RA: 'Raymah',
    SA: 'Amānat al ‘Āşimah',
    SD: 'Şāʻdah',
    SH: 'Shabwah',
    SN: "Şanʻā'",
    TA: 'Tāʻizz',
  },
  ZM: {
    '10': 'Muchinga',
    '01': 'Western',
    '02': 'Central',
    '03': 'Eastern',
    '04': 'Luapula',
    '05': 'Northern',
    '06': 'North-Western',
    '07': 'Southern',
    '08': 'Copperbelt',
    '09': 'Lusaka',
  },
  ZW: {
    BU: 'Bulawayo',
    HA: 'Harare',
    MA: 'Manicaland',
    MC: 'Mashonaland Central',
    ME: 'Mashonaland East',
    MI: 'Midlands',
    MN: 'Matabeleland North',
    MS: 'Matabeleland South',
    MV: 'Masvingo',
    MW: 'Mashonaland West',
  },
}
